"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6720],{

/***/ 90298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getImageUrl; }
/* harmony export */ });
/* harmony import */ var _services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40927);
/* harmony import */ var _services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_0__);

var FALLBACK_IMAGE_FILENAME = "default.png"; // if you don't add this file to your path, you'll have weird "?" image instead in case of missing image
var env = "production";
var getImageUrl = function(folderPath, fileName) {
    var folderPathForEnv = "".concat(folderPath, "/").concat(env);
    var transformation = "".concat(_services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_0__.FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM, "_").concat(folderPathForEnv.replace(/\//g, ":"), ":").concat(FALLBACK_IMAGE_FILENAME, ",q_100");
    return "".concat(_services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_0__.CLOUDINARY_IMAGE_PREFIX, "upload/").concat(transformation, "/").concat(folderPathForEnv, "/").concat(fileName);
};


/***/ }),

/***/ 83139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MANIFEST_PREFETCHED_ASSET_KEYS": function() { return /* binding */ MANIFEST_PREFETCHED_ASSET_KEYS; },
/* harmony export */   "PLATFORM_CDN_URL": function() { return /* binding */ PLATFORM_CDN_URL; },
/* harmony export */   "PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN": function() { return /* binding */ PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN; },
/* harmony export */   "PLATFORM_MANIFEST_ENDPOINT": function() { return /* binding */ PLATFORM_MANIFEST_ENDPOINT; },
/* harmony export */   "PREFETCH_TYPES": function() { return /* binding */ PREFETCH_TYPES; }
/* harmony export */ });
var PREFETCH_TYPES = {
    DNS_PREFETCH: "dns-prefetch",
    PREFETCH: "prefetch",
    PRECONNECT: "preconnect"
};
var isProduction = "production" === "production";
var PLATFORM_STAGING_CDN_URL = "https://multicdn.mondaystaging.com";
var PLATFORM_PROD_CDN_URL = "https://cdn.monday.com";
var PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN = "http://webpack.llama.fan:3444";
var PLATFORM_CDN_URL = isProduction ? PLATFORM_PROD_CDN_URL : PLATFORM_STAGING_CDN_URL;
var PLATFORM_MANIFEST_ENDPOINT = "".concat(PLATFORM_CDN_URL, "/build/manifest.json");
var MANIFEST_PREFETCHED_ASSET_KEYS = [
    "soft_signup.js",
    "soft_signup.css",
    "main.js",
    "main.css",
    "components.js",
    "vendors.js",
    "backbone_init.js",
    "externals.js"
];


/***/ }),

/***/ 42349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$D": function() { return /* binding */ TIERS_STICKY_HEADER_OFFSET; },
/* harmony export */   "I$": function() { return /* binding */ TIER_CARD_PRICE_HEIGHT; },
/* harmony export */   "TR": function() { return /* binding */ CLEAN_FIRST_FOLD_MARGIN; },
/* harmony export */   "Ww": function() { return /* binding */ TIER_CARD_VIDEO_WIDTH; },
/* harmony export */   "ld": function() { return /* binding */ TIERS_STICKY_HEADER_BORDER_OFFSET; },
/* harmony export */   "m6": function() { return /* binding */ TIER_CARD_VIDEO_HEIGHT; },
/* harmony export */   "pP": function() { return /* binding */ PLANS_COMPONENT_WIDTH; }
/* harmony export */ });
/* unused harmony exports PLANS_HEADERS_OFFSET, FREE_TIER_PRICE_HEIGHT */
var HEADER_HEIGHT = 72;
var PLANS_HEADERS_OFFSET = (/* unused pure expression or super */ null && (HEADER_HEIGHT));
var TIERS_STICKY_HEADER_OFFSET = HEADER_HEIGHT;
var TIERS_STICKY_HEADER_BORDER_OFFSET = 107; // sticky header height (82) + first title height (25)
var PLANS_COMPONENT_WIDTH = 1225;
var TIER_CARD_PRICE_HEIGHT = 128;
var FREE_TIER_PRICE_HEIGHT = 142;
var TIER_CARD_VIDEO_WIDTH = 422;
var TIER_CARD_VIDEO_HEIGHT = 284;
var CLEAN_FIRST_FOLD_MARGIN = "10%";


/***/ }),

/***/ 78803:
/***/ (function(module) {


var VERSION_9 = "9";
var VERSION_10 = "10";
var VERSION_11 = "11";
var VERSION_12 = "12";
var VERSION_13 = "13";
var DEFAULT_VERSION = VERSION_13;
var ALLOWED_VERSIONS = [
    VERSION_9,
    VERSION_10,
    VERSION_11,
    VERSION_12,
    VERSION_13
];
module.exports = {
    VERSION_9: VERSION_9,
    VERSION_10: VERSION_10,
    VERSION_11: VERSION_11,
    VERSION_12: VERSION_12,
    VERSION_13: VERSION_13,
    DEFAULT_VERSION: DEFAULT_VERSION,
    ALLOWED_VERSIONS: ALLOWED_VERSIONS
};


/***/ }),

/***/ 61980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ACCOUNT_PERMISSIONS": function() { return /* binding */ ACCOUNT_PERMISSIONS; },
  "ACTIVITY_LOG": function() { return /* binding */ ACTIVITY_LOG; },
  "ADVANCED_COLUMN_TYPES": function() { return /* binding */ ADVANCED_COLUMN_TYPES; },
  "ADVANCED_CUSTOMER_PROJECT_MANAGEMENT": function() { return /* binding */ ADVANCED_CUSTOMER_PROJECT_MANAGEMENT; },
  "APPROVED_GUEST": function() { return /* binding */ APPROVED_GUEST; },
  "AUDIT_LOG": function() { return /* binding */ AUDIT_LOG; },
  "AUTOMATIONS": function() { return /* binding */ AUTOMATIONS; },
  "BLOCK_DOMAINS": function() { return /* binding */ BLOCK_DOMAINS; },
  "BOARDS": function() { return /* binding */ BOARDS; },
  "BOARD_ADMINISTRATORS": function() { return /* binding */ features_BOARD_ADMINISTRATORS; },
  "CALENDAR": function() { return /* binding */ features_CALENDAR; },
  "CHART_VIEW": function() { return /* binding */ CHART_VIEW; },
  "COLLABORATIVE_WHITEBOARD": function() { return /* binding */ COLLABORATIVE_WHITEBOARD; },
  "COLUMN_TYPES": function() { return /* binding */ COLUMN_TYPES; },
  "COMMISSION_MANAGEMENT": function() { return /* binding */ COMMISSION_MANAGEMENT; },
  "COMMUNICATION_WITH_CONTEXT": function() { return /* binding */ COMMUNICATION_WITH_CONTEXT; },
  "CONTENT_DIRECTORY": function() { return /* binding */ CONTENT_DIRECTORY; },
  "CS_MANAGER": function() { return /* binding */ CS_MANAGER; },
  "CUSTOMER_PROJECT_MANAGEMENT": function() { return /* binding */ CUSTOMER_PROJECT_MANAGEMENT; },
  "CUSTOMIZABLE_NOTIFICATIONS": function() { return /* binding */ CUSTOMIZABLE_NOTIFICATIONS; },
  "CUSTOMIZABLE_SALES_PROCESS": function() { return /* binding */ CUSTOMIZABLE_SALES_PROCESS; },
  "CUSTOM_DASHBOARDS": function() { return /* binding */ CUSTOM_DASHBOARDS; },
  "CUSTOM_ROLES": function() { return /* binding */ CUSTOM_ROLES; },
  "DAILY_REPORTS": function() { return /* binding */ DAILY_REPORTS; },
  "DASHBOARDS": function() { return /* binding */ features_DASHBOARDS; },
  "DEADLINE_MANAGEMENT": function() { return /* binding */ DEADLINE_MANAGEMENT; },
  "DEPENDENCY_COLUMN": function() { return /* binding */ DEPENDENCY_COLUMN; },
  "EMAIL_SUPPORT": function() { return /* binding */ EMAIL_SUPPORT; },
  "EMBEDDED_BOARD": function() { return /* binding */ EMBEDDED_BOARD; },
  "EMBED_DOCUMENTS_AND_BRIEFS": function() { return /* binding */ EMBED_DOCUMENTS_AND_BRIEFS; },
  "FILES_MANAGEMENT": function() { return /* binding */ FILES_MANAGEMENT; },
  "FORMS": function() { return /* binding */ features_FORMS; },
  "FORMS_CUSTOMIZATION": function() { return /* binding */ FORMS_CUSTOMIZATION; },
  "FORMULA": function() { return /* binding */ FORMULA; },
  "GOOGLE": function() { return /* binding */ GOOGLE; },
  "GUESTS": function() { return /* binding */ features_GUESTS; },
  "HIPAA": function() { return /* binding */ HIPAA; },
  "IMPORT_EXPORT_EXCEL": function() { return /* binding */ IMPORT_EXPORT_EXCEL; },
  "IMPORT_FROM_OTHER_TOOLS": function() { return /* binding */ IMPORT_FROM_OTHER_TOOLS; },
  "INTEGRATIONS": function() { return /* binding */ features_INTEGRATIONS; },
  "INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK": function() { return /* binding */ INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK; },
  "INTEGRATION_PERMISSIONS": function() { return /* binding */ INTEGRATION_PERMISSIONS; },
  "IP_RESTRICTIONS": function() { return /* binding */ IP_RESTRICTIONS; },
  "ITEMS": function() { return /* binding */ ITEMS; },
  "KANBAN_VIEW": function() { return /* binding */ KANBAN_VIEW; },
  "KNOWLEDGE_BASE": function() { return /* binding */ KNOWLEDGE_BASE; },
  "LEAD_ASSIGNMENT": function() { return /* binding */ LEAD_ASSIGNMENT; },
  "MAP": function() { return /* binding */ MAP; },
  "MARKETING_CALENDAR": function() { return /* binding */ MARKETING_CALENDAR; },
  "MARKETING_DASHBOARDS": function() { return /* binding */ MARKETING_DASHBOARDS; },
  "MARKETING_INTEGRATIONS": function() { return /* binding */ MARKETING_INTEGRATIONS; },
  "MARKETING_REQUESTS_WITH_FORMS": function() { return /* binding */ MARKETING_REQUESTS_WITH_FORMS; },
  "MAXIMUM_SEATS": function() { return /* binding */ MAXIMUM_SEATS; },
  "MOBILE": function() { return /* binding */ MOBILE; },
  "PANIC_MODE": function() { return /* binding */ features_PANIC_MODE; },
  "PIVOT_ANALYSIS": function() { return /* binding */ PIVOT_ANALYSIS; },
  "PREMIUM_INTEGRATIONS": function() { return /* binding */ PREMIUM_INTEGRATIONS; },
  "PRIVATE_BOARDS": function() { return /* binding */ PRIVATE_BOARDS; },
  "PRIVATE_WORKSPACES": function() { return /* binding */ PRIVATE_WORKSPACES; },
  "READY_MADE_MARKETING_TEMPLATES": function() { return /* binding */ READY_MADE_MARKETING_TEMPLATES; },
  "SALESFORCE_INTEGRATION": function() { return /* binding */ SALESFORCE_INTEGRATION; },
  "SAML": function() { return /* binding */ SAML; },
  "SCHEDULED_DASHBOARD_DELIVERY": function() { return /* binding */ SCHEDULED_DASHBOARD_DELIVERY; },
  "SCIM": function() { return /* binding */ SCIM; },
  "SEARCH": function() { return /* binding */ SEARCH; },
  "SEATS_MANAGEMENT": function() { return /* binding */ SEATS_MANAGEMENT; },
  "SESSIONS": function() { return /* binding */ SESSIONS; },
  "SHARE_BOARD_WITH_EXTERNAL_GUESTS": function() { return /* binding */ SHARE_BOARD_WITH_EXTERNAL_GUESTS; },
  "SLA": function() { return /* binding */ SLA; },
  "SOC": function() { return /* binding */ SOC; },
  "STORAGE": function() { return /* binding */ STORAGE; },
  "TAGS": function() { return /* binding */ TAGS; },
  "TAILORED_ONBOARDING": function() { return /* binding */ TAILORED_ONBOARDING; },
  "TEAMS_INSIDE_TEAMS": function() { return /* binding */ TEAMS_INSIDE_TEAMS; },
  "TEMPLATES": function() { return /* binding */ TEMPLATES; },
  "TENANT_RESTRICTIONS": function() { return /* binding */ TENANT_RESTRICTIONS; },
  "TIMELINE": function() { return /* binding */ TIMELINE; },
  "TIME_TRACKING": function() { return /* binding */ TIME_TRACKING; },
  "TWO_FA": function() { return /* binding */ TWO_FA; },
  "TWO_WAY_EMAIL_SYNC": function() { return /* binding */ TWO_WAY_EMAIL_SYNC; },
  "UNLIMITED_BOARDS": function() { return /* binding */ UNLIMITED_BOARDS; },
  "UNLIMITED_BOARDS_WITH_FREE_TIER": function() { return /* binding */ UNLIMITED_BOARDS_WITH_FREE_TIER; },
  "UNLIMITED_DOCS": function() { return /* binding */ UNLIMITED_DOCS; },
  "UNLIMITED_VIEWERS": function() { return /* binding */ UNLIMITED_VIEWERS; },
  "UPDATES_SECTION": function() { return /* binding */ UPDATES_SECTION; },
  "VIEWERS": function() { return /* binding */ VIEWERS; },
  "WEBINARS": function() { return /* binding */ WEBINARS; },
  "WEB_TO_LEAD_CAPTURING": function() { return /* binding */ WEB_TO_LEAD_CAPTURING; },
  "WHITEBOARD": function() { return /* binding */ features_WHITEBOARD; },
  "WORKLOAD": function() { return /* binding */ WORKLOAD; },
  "WORK_PERFORMANCE_INSIGHTS": function() { return /* binding */ WORK_PERFORMANCE_INSIGHTS; },
  "ZOOM_INTEGRATION": function() { return /* binding */ ZOOM_INTEGRATION; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
;// CONCATENATED MODULE: ./constants/free-tier.js
var ITEM_RESOURCE_CREDIT_FOR_FREE_TIER = 200;
var USER_RESOURCE_CREDIT_FOR_FREE_TIER = 2; // every visitor to the homepage gets the same value, regardless of free tier version.

// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./services/ab-tests/free-tier-item-resource-credit-sync-service.js




var getItemResourceCreditCount = function(abTests, cookies) {
    var forcedItemResourceCreditFromPlatform = cookies[constants_cookies.MONDAY_FREE_TIER_ACCOUNT_CREATION_ITEM_RESOURCE_CREDIT_COOKIE_NAME];
    if (forcedItemResourceCreditFromPlatform) return parseInt(forcedItemResourceCreditFromPlatform);
    var resourceCreditAmount = ITEM_RESOURCE_CREDIT_FOR_FREE_TIER;
    if ((0,dom_utils_service.isRunningInClient)()) (0,cookies_service/* setCookie */.d8)(constants_cookies.HOMEPAGE_ACCOUNT_CREATION_ITEM_RESOURCE_CREDIT_COOKIE_NAME, resourceCreditAmount);
    return resourceCreditAmount;
};

// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/features/features_tiers.js


var _obj;
var GENERIC_ALL_TRUE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj);
var _obj1;
var ENTERPRISE_ONLY = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj1);
var WHITEBOARD = GENERIC_ALL_TRUE;
var _obj2;
var INTEGRATIONS = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.integrations_standard"
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.integrations_pro"
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.integrations_enterprise"
}), _obj2);
var FORMS = GENERIC_ALL_TRUE;
var _obj3;
var GUESTS = (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.guests_four_one"
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.unlimited"
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.unlimited"
}), _obj3);
var _obj4;
var DASHBOARDS = (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.FREE */.Iy.FREE, {
    value: "pricingPage.features.plans.dashboards_basic"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: "pricingPage.features.plans.dashboards_basic"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.dashboards_standard"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.dashboards_pro"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.dashboards_enterprise"
}), _obj4);
var _obj5;
var CALENDAR = (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: true
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj5);
var _obj6;
var SCHEDULED_DASHBOARD_DELIVVERY = (_obj6 = {}, (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj6);
var _obj7;
var BOARD_ADMINISTRATORS = (_obj7 = {}, (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj7);
var _obj8;
var PANIC_MODE = (_obj8 = {}, (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj8);

// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/features/features.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var FILES_MANAGEMENT = {
    name: "pricingPage.features.titles.filesManagement",
    description: "pricingPage.features.descriptions.filesManagement",
    tiers: GENERIC_ALL_TRUE
};
var LEAD_ASSIGNMENT = {
    name: "pricingPage.features.titles.leadAssignment",
    description: "pricingPage.features.descriptions.leadAssignment",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMIZABLE_SALES_PROCESS = {
    name: "pricingPage.features.titles.customizableSalesProcess",
    description: "pricingPage.features.descriptions.customizableSalesProcess",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMER_PROJECT_MANAGEMENT = {
    name: "pricingPage.features.titles.customerProjectManagement",
    description: "pricingPage.features.descriptions.customerProjectManagement",
    tiers: GENERIC_ALL_TRUE
};
var WEB_TO_LEAD_CAPTURING = {
    name: "pricingPage.features.titles.webToLeadCapturing",
    description: "pricingPage.features.descriptions.webToLeadCapturing",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOM_DASHBOARDS = {
    name: "pricingPage.features.titles.customDashboards",
    description: "pricingPage.features.descriptions.customDashboards",
    tiers: GENERIC_ALL_TRUE
};
var COMMUNICATION_WITH_CONTEXT = {
    name: "pricingPage.features.titles.communication_with_context",
    description: "pricingPage.features.descriptions.communication_with_context",
    tiers: GENERIC_ALL_TRUE
};
var COLLABORATIVE_WHITEBOARD = {
    name: "pricingPage.features.titles.collaborative_whiteboard",
    description: "pricingPage.features.descriptions.whiteboard",
    tiers: WHITEBOARD
};
var INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK = {
    name: "pricingPage.features.titles.integrations_with_gmail_and_outlook",
    description: "pricingPage.features.descriptions.integrations_with_gmail_and_outlook",
    tiers: INTEGRATIONS
};
var IMPORT_FROM_OTHER_TOOLS = {
    name: "pricingPage.features.titles.importFromOtherTools",
    description: "pricingPage.features.descriptions.importFromOtherTools",
    tiers: GENERIC_ALL_TRUE
};
var EMBED_DOCUMENTS_AND_BRIEFS = {
    name: "pricingPage.features.titles.embed_documents_and_briefs",
    description: "pricingPage.features.descriptions.embed_documents_and_briefs",
    tiers: GENERIC_ALL_TRUE
};
var MARKETING_REQUESTS_WITH_FORMS = {
    name: "pricingPage.features.titles.marketing_requests_with_forms",
    description: "pricingPage.features.descriptions.marketing_requests_with_forms",
    tiers: FORMS
};
var READY_MADE_MARKETING_TEMPLATES = {
    name: "pricingPage.features.titles.ready_made_marketing_templates",
    description: "pricingPage.features.descriptions.ready_made_marketing_templates",
    tiers: GENERIC_ALL_TRUE
};
var TEMPLATES = {
    name: "pricingPage.features.titles.templates",
    description: "pricingPage.features.descriptions.templates",
    tiers: GENERIC_ALL_TRUE
};
var UPDATES_SECTION = {
    name: "pricingPage.features.titles.updatesSection",
    description: "pricingPage.features.descriptions.updatesSection",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMIZABLE_NOTIFICATIONS = {
    name: "pricingPage.features.titles.customizableNotifications",
    description: "pricingPage.features.descriptions.customizableNotifications",
    tiers: GENERIC_ALL_TRUE
};
var DEADLINE_MANAGEMENT = {
    name: "pricingPage.features.titles.deadline_management",
    description: "pricingPage.features.descriptions.deadline_management",
    tiers: GENERIC_ALL_TRUE
};
var SHARE_BOARD_WITH_EXTERNAL_GUESTS = {
    name: "pricingPage.features.titles.share_board_with_external_guests",
    description: "pricingPage.features.descriptions.guests",
    tiers: GUESTS
};
var MARKETING_INTEGRATIONS = {
    name: "pricingPage.features.titles.integrations",
    description: "pricingPage.features.descriptions.marketing_integrations",
    tiers: INTEGRATIONS
};
var MARKETING_DASHBOARDS = {
    name: "pricingPage.features.titles.dashboards",
    description: "pricingPage.features.descriptions.marketing_dashboards",
    tiers: DASHBOARDS
};
var MARKETING_CALENDAR = {
    name: "pricingPage.features.titles.calendar",
    description: "pricingPage.features.descriptions.marketing_calendar",
    tiers: CALENDAR
};
var DAILY_REPORTS = {
    name: "pricingPage.features.titles.daily_reports",
    description: "pricingPage.features.descriptions.daily_reports",
    tiers: SCHEDULED_DASHBOARD_DELIVVERY
};
var IMPORT_EXPORT_EXCEL = {
    name: "pricingPage.features.titles.import_export_excel",
    description: "pricingPage.features.descriptions.import_export_excel",
    tiers: GENERIC_ALL_TRUE
};
var features_WHITEBOARD = {
    name: "pricingPage.features.titles.whiteboard",
    description: "pricingPage.features.descriptions.whiteboard",
    tiers: WHITEBOARD
};
var EMBEDDED_BOARD = {
    name: "pricingPage.features.titles.embed_docs",
    description: "pricingPage.features.descriptions.embed_docs",
    tiers: GENERIC_ALL_TRUE
};
var features_obj;
var ZOOM_INTEGRATION = {
    name: "pricingPage.features.titles.zoom_integration",
    description: "pricingPage.features.descriptions.zoom_integration",
    tiers: (features_obj = {}, (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj)
};
var TIMELINE = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.timeline",
        description: "pricingPage.features.descriptions.timeline",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var features_CALENDAR = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        name: "pricingPage.features.titles.calendar",
        description: "pricingPage.features.descriptions.calendar",
        tiers: _object_spread_props(_object_spread({}, CALENDAR), (0,_define_property/* default */.Z)({}, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }))
    };
};
var features_GUESTS = {
    name: "pricingPage.features.titles.guests",
    description: "pricingPage.features.descriptions.guests",
    tiers: GUESTS
};
var KANBAN_VIEW = {
    name: "pricingPage.features.titles.kanbanView",
    description: "pricingPage.features.descriptions.kanbanView",
    tiers: GENERIC_ALL_TRUE
};
var WEBINARS = {
    name: "pricingPage.features.titles.webinars",
    description: "pricingPage.features.descriptions.webinars",
    tiers: GENERIC_ALL_TRUE
};
var features_FORMS = {
    name: "pricingPage.features.titles.forms",
    description: "pricingPage.features.descriptions.forms",
    tiers: FORMS
};
var features_obj1;
var MAP = {
    name: "pricingPage.features.titles.map",
    description: "pricingPage.features.descriptions.map",
    tiers: (features_obj1 = {}, (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj1)
};
var features_obj2;
var SEARCH = {
    name: "pricingPage.features.titles.search",
    description: "pricingPage.features.descriptions.search",
    tiers: (features_obj2 = {}, (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj2)
};
var features_obj3;
var IP_RESTRICTIONS = {
    name: "pricingPage.features.titles.ip_restrictions",
    description: "pricingPage.features.descriptions.ip_restrictions",
    tiers: (features_obj3 = {}, (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj3)
};
var features_obj4;
var CONTENT_DIRECTORY = {
    name: "pricingPage.features.titles.content_directory",
    description: "pricingPage.features.descriptions.content_directory",
    tiers: (features_obj4 = {}, (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj4)
};
var TEAMS_INSIDE_TEAMS = {
    name: "pricingPage.features.titles.teams_inside_teams",
    description: "pricingPage.features.descriptions.teams_inside_teams",
    tiers: ENTERPRISE_ONLY
};
var CUSTOM_ROLES = {
    name: "pricingPage.features.titles.custom_roles",
    description: "pricingPage.features.descriptions.custom_roles",
    tiers: ENTERPRISE_ONLY
};
var SEATS_MANAGEMENT = {
    name: "pricingPage.features.titles.seats_management",
    description: "pricingPage.features.descriptions.seats_management",
    tiers: ENTERPRISE_ONLY
};
var TENANT_RESTRICTIONS = {
    name: "pricingPage.features.titles.tenant_restrictions",
    description: "pricingPage.features.descriptions.tenant_restrictions",
    tiers: ENTERPRISE_ONLY
};
var APPROVED_GUEST = {
    name: "pricingPage.features.titles.approved_guest",
    description: "pricingPage.features.descriptions.approved_guest",
    tiers: ENTERPRISE_ONLY
};
var BLOCK_DOMAINS = {
    name: "pricingPage.features.titles.block_domains",
    description: "pricingPage.features.descriptions.block_domains",
    tiers: ENTERPRISE_ONLY
};
var FORMS_CUSTOMIZATION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.formsCustomization",
        description: "pricingPage.features.descriptions.formsCustomization",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var features_obj5;
var TWO_WAY_EMAIL_SYNC = {
    name: "pricingPage.features.titles.twoWayEmailSync",
    description: "pricingPage.features.descriptions.twoWayEmailSync",
    tiers: (features_obj5 = {}, (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj5)
};
var features_obj6;
var COMMISSION_MANAGEMENT = {
    name: "pricingPage.features.titles.commissionManagement",
    description: "pricingPage.features.descriptions.commissionManagement",
    tiers: (features_obj6 = {}, (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj6)
};
var features_obj7;
var ADVANCED_CUSTOMER_PROJECT_MANAGEMENT = {
    name: "pricingPage.features.titles.advancedCustomerProjectManagement",
    description: "pricingPage.features.descriptions.advancedCustomerProjectManagement",
    tiers: (features_obj7 = {}, (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj7)
};
var features_obj8;
var WORKLOAD = {
    name: "pricingPage.features.titles.workload",
    description: "pricingPage.features.descriptions.workload",
    tiers: (features_obj8 = {}, (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj8)
};
var _obj9;
var TIME_TRACKING = {
    name: "pricingPage.features.titles.timeTracking",
    description: "pricingPage.features.descriptions.timeTracking",
    tiers: (_obj9 = {}, (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj9)
};
var CHART_VIEW = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.chartView",
        description: "pricingPage.features.descriptions.chartView",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var FORMULA = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.formula",
        description: "pricingPage.features.descriptions.formula",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var _obj10;
var DEPENDENCY_COLUMN = {
    name: "pricingPage.features.titles.dependencyColumn",
    description: "pricingPage.features.descriptions.dependencyColumn",
    tiers: (_obj10 = {}, (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj10)
};
var _obj11;
var TAGS = {
    name: "pricingPage.features.titles.tags",
    description: "pricingPage.features.descriptions.tags",
    tiers: (_obj11 = {}, (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj11)
};
var _obj12;
var PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.privateBoards",
    description: "pricingPage.features.descriptions.privateBoards",
    tiers: (_obj12 = {}, (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj12)
};
var features_INTEGRATIONS = {
    name: "pricingPage.features.titles.integrations",
    description: "pricingPage.features.descriptions.integrations",
    tiers: INTEGRATIONS
};
var _obj13;
var AUTOMATIONS = {
    name: "pricingPage.features.titles.automations",
    description: "pricingPage.features.descriptions.automations",
    tiers: (_obj13 = {}, (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.automations_standard"
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.automations_pro"
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.automations_enterprise"
    }), _obj13)
};
var _obj14;
var PREMIUM_INTEGRATIONS = {
    name: "pricingPage.features.titles.premiumIntegrations",
    description: "pricingPage.features.descriptions.premiumIntegrations",
    tiers: (_obj14 = {}, (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj14)
};
var features_DASHBOARDS = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        name: "pricingPage.features.titles.dashboards",
        description: "pricingPage.features.descriptions.dashboards",
        tiers: _object_spread_props(_object_spread({}, DASHBOARDS), (0,_define_property/* default */.Z)({}, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: "pricingPage.features.plans.dashboards_pro"
        } : {
            value: "pricingPage.features.plans.dashboards_basic"
        }))
    };
};
var TWO_FA = {
    name: "pricingPage.features.titles.twoFa",
    description: "pricingPage.features.descriptions.twoFa",
    tiers: GENERIC_ALL_TRUE
};
var _obj15;
var GOOGLE = {
    name: "pricingPage.features.titles.google",
    description: "pricingPage.features.descriptions.google",
    tiers: (_obj15 = {}, (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj15)
};
var features_BOARD_ADMINISTRATORS = {
    name: "pricingPage.features.titles.boardAdministrators",
    description: "pricingPage.features.descriptions.boardAdministrators",
    tiers: BOARD_ADMINISTRATORS
};
var _obj16;
var SAML = {
    name: "pricingPage.features.titles.saml",
    description: "pricingPage.features.descriptions.saml",
    tiers: (_obj16 = {}, (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj16)
};
var _obj17;
var SCIM = {
    name: "pricingPage.features.titles.scimProvisioning",
    description: "pricingPage.features.descriptions.scimProvisioning",
    tiers: (_obj17 = {}, (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj17)
};
var _obj18;
var AUDIT_LOG = {
    name: "pricingPage.features.titles.auditLog",
    description: "pricingPage.features.descriptions.auditLog",
    tiers: (_obj18 = {}, (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj18)
};
var _obj19;
var SESSIONS = {
    name: "pricingPage.features.titles.sessions",
    description: "pricingPage.features.descriptions.sessions",
    tiers: (_obj19 = {}, (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj19)
};
var features_PANIC_MODE = {
    name: "pricingPage.features.titles.panicMode",
    description: "pricingPage.features.descriptions.panicMode",
    tiers: PANIC_MODE
};
var _obj20;
var HIPAA = {
    name: "pricingPage.features.titles.hipaa",
    description: "pricingPage.features.descriptions.hipaa",
    tiers: (_obj20 = {}, (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj20)
};
var SOC = {
    name: "pricingPage.features.titles.soc",
    description: "pricingPage.features.descriptions.soc",
    tiers: GENERIC_ALL_TRUE
};
var _obj21;
var SLA = {
    name: "pricingPage.features.titles.sla",
    description: "pricingPage.features.descriptions.sla",
    tiers: (_obj21 = {}, (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj21)
};
var _obj22;
var CS_MANAGER = {
    name: "pricingPage.features.titles.csManager",
    description: "pricingPage.features.descriptions.csManager",
    tiers: (_obj22 = {}, (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj22)
};
var _obj23;
var INTEGRATION_PERMISSIONS = {
    name: "pricingPage.features.titles.integrationPermissions",
    description: "pricingPage.features.descriptions.integrationPermissions",
    tiers: (_obj23 = {}, (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj23)
};
var _obj24;
var SALESFORCE_INTEGRATION = {
    name: "pricingPage.features.titles.salesforceIntegration",
    description: "pricingPage.features.descriptions.salesforceIntegration",
    tiers: (_obj24 = {}, (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj24)
};
var _obj25;
var PRIVATE_WORKSPACES = {
    name: "pricingPage.features.titles.privateWorkspaces",
    description: "pricingPage.features.descriptions.privateWorkspaces",
    tiers: (_obj25 = {}, (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj25)
};
var _obj26;
var ACCOUNT_PERMISSIONS = {
    name: "pricingPage.features.titles.accountPermissions",
    description: "pricingPage.features.descriptions.accountPermissions",
    tiers: (_obj26 = {}, (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj26)
};
var _obj27;
var WORK_PERFORMANCE_INSIGHTS = {
    name: "pricingPage.features.titles.workPerformanceInsights",
    description: "pricingPage.features.descriptions.workPerformanceInsights",
    tiers: (_obj27 = {}, (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj27)
};
var SCHEDULED_DASHBOARD_DELIVERY = {
    name: "pricingPage.features.titles.dashboardEmailNotifications",
    description: "pricingPage.features.descriptions.dashboardEmailNotifications",
    tiers: SCHEDULED_DASHBOARD_DELIVVERY
};
var _obj28;
var PIVOT_ANALYSIS = {
    name: "pricingPage.features.titles.pivotAnalysis",
    description: "pricingPage.features.descriptions.pivotAnalysis",
    tiers: (_obj28 = {}, (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj28)
};
var KNOWLEDGE_BASE = {
    name: "pricingPage.features.titles.knowledgeBase",
    description: "pricingPage.features.descriptions.knowledgeBase",
    tiers: GENERIC_ALL_TRUE
};
var EMAIL_SUPPORT = {
    name: "pricingPage.features.titles.emailSupport",
    description: "pricingPage.features.descriptions.emailSupport",
    tiers: GENERIC_ALL_TRUE
};
var _obj29;
var TAILORED_ONBOARDING = {
    name: "pricingPage.features.titles.tailoredOnboarding",
    description: "pricingPage.features.descriptions.tailoredOnboarding",
    tiers: (_obj29 = {}, (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj29)
};
var _obj30;
var UNLIMITED_VIEWERS = {
    name: "pricingPage.features.titles.unlimitedViewers",
    description: "pricingPage.features.descriptions.viewers",
    tiers: (_obj30 = {}, (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj30)
};
var UNLIMITED_BOARDS = {
    name: "pricingPage.features.titles.unlimitedBoards",
    description: "pricingPage.features.descriptions.boards",
    tiers: GENERIC_ALL_TRUE
};
var UNLIMITED_DOCS = {
    name: "pricingPage.features.titles.unlimitedDocs",
    description: "pricingPage.features.descriptions.docs",
    tiers: GENERIC_ALL_TRUE
};
var COLUMN_TYPES = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies;
    var _obj;
    return {
        name: "pricingPage.features.titles.columnTypes",
        description: "pricingPage.features.descriptions.columnTypes",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: (0,monetization_ab_tests_service/* getIsFreeOver20ColumnTypes */._n)({
                cookies: cookies
            })
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var _obj31;
var MAXIMUM_SEATS = {
    name: "pricingPage.features.titles.maximumSeats",
    description: "pricingPage.features.descriptions.maximumSeats",
    tiers: (_obj31 = {}, (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.FREE */.Iy.FREE, {
        value: {
            key: "pricingPage.upToXSeats",
            param: pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3
        }
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.unlimited"
    }), _obj31)
};
var MOBILE = {
    name: "pricingPage.features.titles.mobile",
    description: "pricingPage.features.descriptions.mobile",
    tiers: GENERIC_ALL_TRUE
};
var STORAGE = function(param) {
    var cookies = param.cookies, abTests = param.abTests;
    return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, false) ? BIGGER_STORAGE_FEATURE : STORAGE_FEATURE;
};
var _obj32;
var STORAGE_FEATURE = {
    name: "pricingPage.features.titles.storage",
    id: pricing/* FEATURES_IDS.STORAGE */.U1.STORAGE,
    description: "pricingPage.features.descriptions.storage",
    onVisible: {
        callback: function(param) {
            var abTests = param.abTests, cookies = param.cookies;
            return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, true);
        },
        onlyOnce: true
    },
    tiers: (_obj32 = {}, (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.storage_free"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.storage_basic"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.storage_standard"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.storage_pro"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.storage_enterprise"
    }), _obj32)
};
var _obj33;
var BIGGER_STORAGE_FEATURE = {
    name: "pricingPage.features.titles.storage",
    description: "pricingPage.features.descriptions.storage",
    id: pricing/* FEATURES_IDS.STORAGE */.U1.STORAGE,
    onVisible: {
        callback: function(param) {
            var abTests = param.abTests, cookies = param.cookies;
            return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, true);
        },
        onlyOnce: true
    },
    tiers: (_obj33 = {}, (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.storage_free"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.storage_basic"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.storage_standard"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.storage_pro_bigger"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.storage_enterprise_bigger"
    }), _obj33)
};
var _obj34;
var ACTIVITY_LOG = {
    name: "pricingPage.features.titles.activityLog",
    description: "pricingPage.features.descriptions.activityLog",
    tiers: (_obj34 = {}, (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.one_week"
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.one_week"
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.six_months"
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.one_year"
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.five_years"
    }), _obj34)
};
var _obj35;
var ADVANCED_COLUMN_TYPES = {
    name: "pricingPage.features.titles.advancedColumnTypes",
    description: "pricingPage.features.descriptions.columnTypes",
    tiers: (_obj35 = {}, (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj35)
};
var _obj36;
var VIEWERS = {
    name: "pricingPage.features.titles.viewers",
    description: "pricingPage.features.descriptions.viewers",
    tiers: (_obj36 = {}, (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj36)
};
var _obj37;
var BOARDS = {
    name: "pricingPage.features.titles.boards",
    description: "pricingPage.features.descriptions.boards",
    tiers: (_obj37 = {}, (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.unlimited"
    }), _obj37)
};
var ITEMS = function(param) {
    var abTests = param.abTests, cookies = param.cookies;
    var _obj;
    return {
        name: "pricingPage.features.titles.items",
        description: {
            key: "pricingPage.features.descriptions.items",
            param: getItemResourceCreditCount(abTests, cookies)
        },
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: "pricingPage.features.plans.upToOneK"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: "pricingPage.features.plans.unlimited"
        }), _obj)
    };
};
var UNLIMITED_BOARDS_WITH_FREE_TIER = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests;
    var _obj;
    return {
        name: "pricingPage.features.titles.unlimitedBoards",
        description: "pricingPage.features.descriptions.boards",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: (0,monetization_ab_tests_service/* getIsUnlimitedBoards */.J6)({
                cookies: cookies,
                abTests: abTests
            })
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};


/***/ }),

/***/ 78217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$4": function() { return /* binding */ ENTERPRISE_TIER_VALUE_FEATURES; },
/* harmony export */   "b5": function() { return /* binding */ STUDENT_PLAN_VALUE_FEATURES; },
/* harmony export */   "cN": function() { return /* binding */ BASIC_TIER_VALUE_FEATURES; },
/* harmony export */   "kh": function() { return /* binding */ STANDARD_TIER_VALUE_FEATURES; },
/* harmony export */   "tE": function() { return /* binding */ PRO_TIER_VALUE_FEATURES; },
/* harmony export */   "tL": function() { return /* binding */ FREE_TIER_VALUE_FEATURES; }
/* harmony export */ });
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var _value_features__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49127);


var FREE_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UP_TO_X_TEAM_MEMBERS(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .FREE_TIER_2021_SEATS_LIMIT */ .F3),
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE
];
var BASIC_TIER_VALUE_FEATURES = function(param) {
    var hasFreeTier = param.hasFreeTier;
    if (hasFreeTier) {
        return [
            _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_ITEMS,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.FIVE_GB_STORAGE,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIORITISED_CUSTOMER_SUPPORT,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.SINGLE_DASHBOARD
        ];
    }
    return [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.SINGLE_DASHBOARD
    ];
};
var STANDARD_TIER_VALUE_FEATURES = function(param) {
    var withoutBasic = param.withoutBasic, hasFreeTier = param.hasFreeTier;
    return withoutBasic ? hasFreeTier ? [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_ITEMS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIORITISED_CUSTOMER_SUPPORT,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS
    ] : [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE
    ] : [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS
    ];
};
var PRO_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIVATE_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.CHART_VIEW,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.TIME_TRACKING,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.FORMULA,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.DEPENDENCY,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_AUTOMATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_INTEGRATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_DASHBOARDS
];
var STUDENT_PLAN_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.CHART_VIEW
];
var ENTERPRISE_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_SCALE_AUTOMATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_GRADE_SECURITY,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ADVANCED_REPORTING,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MULTI_LEVEL_PERMISSIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.TAILORED_ONBOARDING,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PREMIUM_SUPPORT,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_DASHBOARDS
];


/***/ }),

/***/ 49127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADOBE_CREATIVE_CLOUD_PLUGIN": function() { return /* binding */ ADOBE_CREATIVE_CLOUD_PLUGIN; },
/* harmony export */   "ADVANCED_FORMULA_CAPABILITIES": function() { return /* binding */ ADVANCED_FORMULA_CAPABILITIES; },
/* harmony export */   "ADVANCED_PERMISSIONS": function() { return /* binding */ ADVANCED_PERMISSIONS; },
/* harmony export */   "ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT": function() { return /* binding */ ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT; },
/* harmony export */   "ADVANCED_REPORTING": function() { return /* binding */ ADVANCED_REPORTING; },
/* harmony export */   "ADVANCED_REPORTS": function() { return /* binding */ ADVANCED_REPORTS; },
/* harmony export */   "AGILE_REPORTING": function() { return /* binding */ AGILE_REPORTING; },
/* harmony export */   "API_ACCESS": function() { return /* binding */ API_ACCESS; },
/* harmony export */   "ASSETS_AND_FILE_MANAGEMENT": function() { return /* binding */ ASSETS_AND_FILE_MANAGEMENT; },
/* harmony export */   "BASIC_ANALYTICS_AND_DASHBOARDS": function() { return /* binding */ BASIC_ANALYTICS_AND_DASHBOARDS; },
/* harmony export */   "BOARD_PERMISSIONS": function() { return /* binding */ BOARD_PERMISSIONS; },
/* harmony export */   "BUILT_IN_WORKOCS": function() { return /* binding */ BUILT_IN_WORKOCS; },
/* harmony export */   "CALENDAR": function() { return /* binding */ CALENDAR; },
/* harmony export */   "CALENDAR_SYNC": function() { return /* binding */ CALENDAR_SYNC; },
/* harmony export */   "CAMPAIGN_MANAGEMENT": function() { return /* binding */ CAMPAIGN_MANAGEMENT; },
/* harmony export */   "CHART_VIEW": function() { return /* binding */ CHART_VIEW; },
/* harmony export */   "COLUMN_TYPES": function() { return /* binding */ COLUMN_TYPES; },
/* harmony export */   "COMMUNICATION_WITH_CONTEXT": function() { return /* binding */ COMMUNICATION_WITH_CONTEXT; },
/* harmony export */   "CUSTOMIZED_NOTIFICATIONS": function() { return /* binding */ CUSTOMIZED_NOTIFICATIONS; },
/* harmony export */   "CUSTOM_NOTIFICATIONS_AND_REMINDERS": function() { return /* binding */ CUSTOM_NOTIFICATIONS_AND_REMINDERS; },
/* harmony export */   "DEADLINE_MANAGEMENT": function() { return /* binding */ DEADLINE_MANAGEMENT; },
/* harmony export */   "DEPENDENCY": function() { return /* binding */ DEPENDENCY; },
/* harmony export */   "DEV_FEEDBACK_FORMS": function() { return /* binding */ DEV_FEEDBACK_FORMS; },
/* harmony export */   "DEV_TEMPLATES": function() { return /* binding */ DEV_TEMPLATES; },
/* harmony export */   "DOCUMENT_MANAGEMENT": function() { return /* binding */ DOCUMENT_MANAGEMENT; },
/* harmony export */   "EMAIL_INTEGRATION": function() { return /* binding */ EMAIL_INTEGRATION; },
/* harmony export */   "ENTERPRISE_DASHBOARDS": function() { return /* binding */ ENTERPRISE_DASHBOARDS; },
/* harmony export */   "ENTERPRISE_GRADE_SECURITY": function() { return /* binding */ ENTERPRISE_GRADE_SECURITY; },
/* harmony export */   "ENTERPRISE_INTEGRATIONS": function() { return /* binding */ ENTERPRISE_INTEGRATIONS; },
/* harmony export */   "ENTERPRISE_SCALE_AUTOMATIONS": function() { return /* binding */ ENTERPRISE_SCALE_AUTOMATIONS; },
/* harmony export */   "ENTERPRISE_SPECIFIC_INTEGRATIONS": function() { return /* binding */ ENTERPRISE_SPECIFIC_INTEGRATIONS; },
/* harmony export */   "FILE_MANAGEMENT": function() { return /* binding */ FILE_MANAGEMENT; },
/* harmony export */   "FILTERS": function() { return /* binding */ FILTERS; },
/* harmony export */   "FIVE_GB_STORAGE": function() { return /* binding */ FIVE_GB_STORAGE; },
/* harmony export */   "FORMS": function() { return /* binding */ FORMS; },
/* harmony export */   "FORMULA": function() { return /* binding */ FORMULA; },
/* harmony export */   "FULL_MOBILE_CRM": function() { return /* binding */ FULL_MOBILE_CRM; },
/* harmony export */   "GANTT_CHARTS": function() { return /* binding */ GANTT_CHARTS; },
/* harmony export */   "GIT_INTEGRATIONS": function() { return /* binding */ GIT_INTEGRATIONS; },
/* harmony export */   "GUESTS": function() { return /* binding */ GUESTS; },
/* harmony export */   "HIGH_LEVEL_MARKETING_PLANNING": function() { return /* binding */ HIGH_LEVEL_MARKETING_PLANNING; },
/* harmony export */   "IMPORT_EXPORT_EXCEL": function() { return /* binding */ IMPORT_EXPORT_EXCEL; },
/* harmony export */   "KANBAN_MANAGEMENT": function() { return /* binding */ KANBAN_MANAGEMENT; },
/* harmony export */   "KANBAN_VIEW": function() { return /* binding */ KANBAN_VIEW; },
/* harmony export */   "LEAD_MANAGEMENT": function() { return /* binding */ LEAD_MANAGEMENT; },
/* harmony export */   "LIMITED_COLUMN_TYPES": function() { return /* binding */ LIMITED_COLUMN_TYPES; },
/* harmony export */   "MAILCHIMP_INTEGRATION": function() { return /* binding */ MAILCHIMP_INTEGRATION; },
/* harmony export */   "MARKETING_ACTIVITY_MANAGEMENT": function() { return /* binding */ MARKETING_ACTIVITY_MANAGEMENT; },
/* harmony export */   "MARKETING_ANALYTICS": function() { return /* binding */ MARKETING_ANALYTICS; },
/* harmony export */   "MARKETING_REQUESTS_WITH_FORMS": function() { return /* binding */ MARKETING_REQUESTS_WITH_FORMS; },
/* harmony export */   "MARKETING_TEMPLATES": function() { return /* binding */ MARKETING_TEMPLATES; },
/* harmony export */   "MILESTONES_MANAGEMENT": function() { return /* binding */ MILESTONES_MANAGEMENT; },
/* harmony export */   "MOBILE": function() { return /* binding */ MOBILE; },
/* harmony export */   "MULTI_LEVEL_PERMISSIONS": function() { return /* binding */ MULTI_LEVEL_PERMISSIONS; },
/* harmony export */   "OVER_200_TEMPLATES": function() { return /* binding */ OVER_200_TEMPLATES; },
/* harmony export */   "POWERFUL_ANALYTICS_AND_DASHBOARDS": function() { return /* binding */ POWERFUL_ANALYTICS_AND_DASHBOARDS; },
/* harmony export */   "PREMIUM_SUPPORT": function() { return /* binding */ PREMIUM_SUPPORT; },
/* harmony export */   "PRIORITISED_CUSTOMER_SUPPORT": function() { return /* binding */ PRIORITISED_CUSTOMER_SUPPORT; },
/* harmony export */   "PRIVATE_BOARDS": function() { return /* binding */ PRIVATE_BOARDS; },
/* harmony export */   "PRO_AUTOMATIONS": function() { return /* binding */ PRO_AUTOMATIONS; },
/* harmony export */   "PRO_DASHBOARDS": function() { return /* binding */ PRO_DASHBOARDS; },
/* harmony export */   "PRO_INTEGRATIONS": function() { return /* binding */ PRO_INTEGRATIONS; },
/* harmony export */   "RESOURCE_ALLOCATION": function() { return /* binding */ RESOURCE_ALLOCATION; },
/* harmony export */   "SALES_ANALYTICS": function() { return /* binding */ SALES_ANALYTICS; },
/* harmony export */   "SALES_GOALS": function() { return /* binding */ SALES_GOALS; },
/* harmony export */   "SEARCH": function() { return /* binding */ SEARCH; },
/* harmony export */   "SHARABLE_DEV_BOARDS": function() { return /* binding */ SHARABLE_DEV_BOARDS; },
/* harmony export */   "SHARE_INSIGHTS_WITH_GUESTS": function() { return /* binding */ SHARE_INSIGHTS_WITH_GUESTS; },
/* harmony export */   "SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT": function() { return /* binding */ SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT; },
/* harmony export */   "SINGLE_DASHBOARD": function() { return /* binding */ SINGLE_DASHBOARD; },
/* harmony export */   "SLACK_MSTEAMS_TODOIST_INTEGRATIONS": function() { return /* binding */ SLACK_MSTEAMS_TODOIST_INTEGRATIONS; },
/* harmony export */   "SOCIAL_CALENDAR": function() { return /* binding */ SOCIAL_CALENDAR; },
/* harmony export */   "SPRINT_MANAGEMENT": function() { return /* binding */ SPRINT_MANAGEMENT; },
/* harmony export */   "STANDARD_AUTOMATIONS": function() { return /* binding */ STANDARD_AUTOMATIONS; },
/* harmony export */   "STANDARD_DASHBOARDS": function() { return /* binding */ STANDARD_DASHBOARDS; },
/* harmony export */   "STANDARD_INTEGRATIONS": function() { return /* binding */ STANDARD_INTEGRATIONS; },
/* harmony export */   "TAILORED_ONBOARDING": function() { return /* binding */ TAILORED_ONBOARDING; },
/* harmony export */   "TASK_AND_PROJECT_DEPENDENCIES": function() { return /* binding */ TASK_AND_PROJECT_DEPENDENCIES; },
/* harmony export */   "TIMELINE": function() { return /* binding */ TIMELINE; },
/* harmony export */   "TIMELINE_AND_CALENDAR": function() { return /* binding */ TIMELINE_AND_CALENDAR; },
/* harmony export */   "TIMELINE_AND_GANTT_VIEWS": function() { return /* binding */ TIMELINE_AND_GANTT_VIEWS; },
/* harmony export */   "TIME_TRACKING": function() { return /* binding */ TIME_TRACKING; },
/* harmony export */   "UNLIMITED_BOARDS": function() { return /* binding */ UNLIMITED_BOARDS; },
/* harmony export */   "UNLIMITED_CONTACTS": function() { return /* binding */ UNLIMITED_CONTACTS; },
/* harmony export */   "UNLIMITED_CUSTOM_FIELDS": function() { return /* binding */ UNLIMITED_CUSTOM_FIELDS; },
/* harmony export */   "UNLIMITED_DOCS": function() { return /* binding */ UNLIMITED_DOCS; },
/* harmony export */   "UNLIMITED_GUESTS": function() { return /* binding */ UNLIMITED_GUESTS; },
/* harmony export */   "UNLIMITED_ITEMS": function() { return /* binding */ UNLIMITED_ITEMS; },
/* harmony export */   "UNLIMITED_PIPELINES": function() { return /* binding */ UNLIMITED_PIPELINES; },
/* harmony export */   "UNLIMITED_PRIVATE_BOARDS": function() { return /* binding */ UNLIMITED_PRIVATE_BOARDS; },
/* harmony export */   "UNLIMITED_PROJECTS_ITEMS_SUBITEMS": function() { return /* binding */ UNLIMITED_PROJECTS_ITEMS_SUBITEMS; },
/* harmony export */   "UNLIMITED_SHAREABLE_FORMS": function() { return /* binding */ UNLIMITED_SHAREABLE_FORMS; },
/* harmony export */   "UNLIMITED_TEMPLATES": function() { return /* binding */ UNLIMITED_TEMPLATES; },
/* harmony export */   "UNLIMITED_VIEWERS": function() { return /* binding */ UNLIMITED_VIEWERS; },
/* harmony export */   "UP_TO_THREE_BOARDS": function() { return /* binding */ UP_TO_THREE_BOARDS; },
/* harmony export */   "UP_TO_X_TEAM_MEMBERS": function() { return /* binding */ UP_TO_X_TEAM_MEMBERS; },
/* harmony export */   "WHITEBOARD": function() { return /* binding */ WHITEBOARD; },
/* harmony export */   "WORKFLOW_AND_APPROVAL_AUTOMATION": function() { return /* binding */ WORKFLOW_AND_APPROVAL_AUTOMATION; },
/* harmony export */   "WORK_PERFORMANCE_INSIGHTS": function() { return /* binding */ WORK_PERFORMANCE_INSIGHTS; }
/* harmony export */ });
/* harmony import */ var constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42349);

var UNLIMITED_BOARDS = {
    name: "pricingPage.features.titles.unlimitedBoards",
    text: "pricingPage.features.descriptions.boards"
};
var UP_TO_THREE_BOARDS = {
    name: "pricingPage.features.titles.upTo3Boards",
    text: "pricingPage.features.descriptions.boards"
};
var UNLIMITED_DOCS = {
    name: "pricingPage.features.titles.unlimitedDocs",
    text: "pricingPage.features.descriptions.docs"
};
var UNLIMITED_ITEMS = {
    name: "pricingPage.features.titles.unlimitedItems",
    text: "pricingPage.features.descriptions.unlimitedItems"
};
var FIVE_GB_STORAGE = {
    name: "pricingPage.features.titles.fiveGBStorage",
    text: "pricingPage.features.descriptions.storage"
};
var UP_TO_X_TEAM_MEMBERS = function(teamMembersCount) {
    return {
        name: {
            key: "pricingPage.features.titles.upToXMembers",
            param: teamMembersCount
        },
        text: {
            key: "pricingPage.features.descriptions.upToXMembers",
            param: teamMembersCount
        }
    };
};
var PRIORITISED_CUSTOMER_SUPPORT = {
    name: "pricingPage.features.titles.prioritisedCustomerSupport",
    text: "pricingPage.features.descriptions.prioritisedCustomerSupport"
};
var OVER_200_TEMPLATES = {
    name: "pricingPage.features.titles.templates",
    text: "pricingPage.features.descriptions.templates"
};
var COLUMN_TYPES = {
    name: "pricingPage.features.titles.columnTypes",
    text: "pricingPage.features.descriptions.columnTypes"
};
var LIMITED_COLUMN_TYPES = {
    name: "pricingPage.features.titles.limitedColumnTypes",
    text: "pricingPage.features.descriptions.columnTypes"
};
var COMMUNICATION_WITH_CONTEXT = {
    name: "pricingPage.features.titles.communication_with_context",
    text: "pricingPage.features.descriptions.communication_with_context",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Communication_-_updates.mp4")
};
var FORMS = {
    name: "pricingPage.features.titles.forms.simple",
    text: "pricingPage.features.descriptions.forms",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Form.mp4")
};
var KANBAN_VIEW = {
    name: "pricingPage.features.titles.kanbanView",
    text: "pricingPage.features.descriptions.kanbanView"
};
var WHITEBOARD = {
    name: "pricingPage.features.titles.whiteboard",
    text: "pricingPage.features.descriptions.whiteboard"
};
var MOBILE = {
    name: "pricingPage.features.titles.mobile",
    text: "pricingPage.features.descriptions.mobile"
};
var UNLIMITED_VIEWERS = {
    name: "pricingPage.features.titles.unlimitedViewers",
    text: "pricingPage.features.descriptions.viewers"
};
var LEAD_MANAGEMENT = {
    name: "pricingPage.features.titles.leadManagement",
    text: "pricingPage.features.descriptions.leadManagement"
};
var UNLIMITED_PIPELINES = {
    name: "pricingPage.features.titles.unlimitedPipelines",
    text: "pricingPage.features.descriptions.unlimitedPipelines"
};
var UNLIMITED_CONTACTS = {
    name: "pricingPage.features.titles.unlimitedContacts",
    text: "pricingPage.features.descriptions.unlimitedContacts"
};
var UNLIMITED_CUSTOM_FIELDS = {
    name: "pricingPage.features.titles.unlimitedCustomFields",
    text: "pricingPage.features.descriptions.unlimitedCustomFields"
};
var FULL_MOBILE_CRM = {
    name: "pricingPage.features.titles.fullMobileCRM",
    text: "pricingPage.features.descriptions.fullMobileCRM"
};
var DOCUMENT_MANAGEMENT = {
    name: "pricingPage.features.titles.documentManagement",
    text: "pricingPage.features.descriptions.documentManagement"
};
var API_ACCESS = {
    name: "pricingPage.features.titles.apiAccess",
    text: "pricingPage.features.descriptions.apiAccess"
};
var SINGLE_DASHBOARD = {
    name: "pricingPage.features.titles.basicDashboards",
    text: "pricingPage.features.descriptions.dashboards"
};
var TIMELINE_AND_GANTT_VIEWS = {
    name: "pricingPage.features.titles.timelineAndGanttView",
    text: "pricingPage.features.descriptions.timelineAndGanttView"
};
var TIMELINE = {
    name: "pricingPage.features.titles.timeline",
    text: "pricingPage.features.descriptions.timeline"
};
var CALENDAR = {
    name: "pricingPage.features.titles.calendar",
    text: "pricingPage.features.descriptions.calendar"
};
var TIMELINE_AND_CALENDAR = {
    name: "pricingPage.features.titles.timelineAndCalendarView",
    text: "pricingPage.features.descriptions.timelineAndCalendarView",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, "/remote_mondaycom_static/developers/features/Timeline_view.mp4")
};
var FILTERS = {
    name: "pricingPage.features.titles.filters",
    text: "pricingPage.features.descriptions.filters"
};
var SEARCH = {
    name: "pricingPage.features.titles.search",
    text: "pricingPage.features.descriptions.search"
};
var GUESTS = {
    name: "pricingPage.features.titles.guests",
    text: "pricingPage.features.descriptions.guests"
};
var EMAIL_INTEGRATION = {
    name: "pricingPage.features.titles.emailIntegration",
    text: "pricingPage.features.descriptions.emailIntegration"
};
var SALES_ANALYTICS = {
    name: "pricingPage.features.titles.salesAnalytics",
    text: "pricingPage.features.descriptions.salesAnalytics"
};
var MAILCHIMP_INTEGRATION = {
    name: "pricingPage.features.titles.mailchimpIntegration",
    text: "pricingPage.features.descriptions.mailchimpIntegration"
};
var SALES_GOALS = {
    name: "pricingPage.features.titles.salesGoals",
    text: "pricingPage.features.descriptions.salesGoals"
};
var STANDARD_DASHBOARDS = {
    name: "pricingPage.features.titles.standardDashboards",
    text: "pricingPage.features.descriptions.dashboards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Dashboard_standard.mp4")
};
var STANDARD_AUTOMATIONS = {
    name: "pricingPage.valueFeatures.titles.automations.standard",
    text: "pricingPage.features.descriptions.automations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Automations.mp4")
};
var STANDARD_INTEGRATIONS = {
    name: "pricingPage.valueFeatures.titles.integrations.standard",
    text: "pricingPage.features.descriptions.integrations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Integrations.mp4")
};
var PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.privateBoards",
    text: "pricingPage.features.descriptions.privateBoards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Private_board.mp4")
};
var BOARD_PERMISSIONS = {
    name: "pricingPage.features.titles.boardPermissions",
    text: "pricingPage.features.descriptions.boardPermissions",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Board_permission.mp4")
};
var CHART_VIEW = {
    name: "pricingPage.features.titles.chartView",
    text: "pricingPage.features.descriptions.chartView",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Chart_view.mp4")
};
var TIME_TRACKING = {
    name: "pricingPage.features.titles.timeTracking",
    text: "pricingPage.features.descriptions.timeTracking"
};
var FORMULA = {
    name: "pricingPage.features.titles.formula",
    text: "pricingPage.features.descriptions.formula"
};
var DEPENDENCY = {
    name: "pricingPage.features.titles.dependencyColumn",
    text: "pricingPage.features.descriptions.dependencyColumn"
};
var UNLIMITED_GUESTS = {
    name: "pricingPage.features.titles.unlimitedGuests",
    text: ""
};
var CUSTOMIZED_NOTIFICATIONS = {
    name: "pricingPage.features.titles.customizedNotifications",
    text: "pricingPage.features.descriptions.customizedNotifications"
};
var MARKETING_ACTIVITY_MANAGEMENT = {
    name: "pricingPage.features.titles.marketingActivityManagement",
    text: "pricingPage.features.descriptions.marketingActivityManagement"
};
var ADVANCED_PERMISSIONS = {
    name: "pricingPage.features.titles.advancedPermissions",
    text: "pricingPage.features.descriptions.boardPermissions"
};
var WORKFLOW_AND_APPROVAL_AUTOMATION = {
    name: "pricingPage.features.titles.workflowAndApprovalAutomation",
    text: "pricingPage.features.descriptions.workflowAndApprovalAutomation"
};
var ADVANCED_REPORTS = {
    name: "pricingPage.features.titles.advancedReports",
    text: "pricingPage.features.descriptions.dashboards"
};
var PRO_DASHBOARDS = {
    name: "pricingPage.features.titles.proDashboards",
    text: "pricingPage.features.descriptions.dashboards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Dashboard.mp4")
};
var PRO_AUTOMATIONS = {
    name: "pricingPage.valueFeatures.titles.automations.pro",
    text: "pricingPage.features.descriptions.automations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Automations.mp4")
};
var PRO_INTEGRATIONS = {
    name: "pricingPage.valueFeatures.titles.integrations.pro",
    text: "pricingPage.features.descriptions.integrations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Integrations.mp4")
};
var ENTERPRISE_SCALE_AUTOMATIONS = {
    name: "pricingPage.features.titles.enterpriseScaleAutomations",
    text: "pricingPage.features.descriptions.enterpriseScaleAutomations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680"
};
var ENTERPRISE_SPECIFIC_INTEGRATIONS = {
    name: "pricingPage.features.titles.enterpriseSpecificIntegrations",
    text: "pricingPage.features.descriptions.enterpriseSpecifciIntegrations"
};
var ENTERPRISE_GRADE_SECURITY = {
    name: "pricingPage.features.titles.enterpriseGradeSecurity",
    text: "pricingPage.features.descriptions.enterpriseGradeSecurity"
};
var ADVANCED_REPORTING = {
    name: "pricingPage.features.titles.advancedReporting",
    text: "pricingPage.features.descriptions.advancedReporting"
};
var MULTI_LEVEL_PERMISSIONS = {
    name: "pricingPage.features.titles.multiLevelPermissions",
    text: "pricingPage.features.descriptions.multiLevelPermissions"
};
var TAILORED_ONBOARDING = {
    name: "pricingPage.features.titles.tailoredOnboarding",
    text: "pricingPage.features.descriptions.tailoredOnboarding"
};
var PREMIUM_SUPPORT = {
    name: "pricingPage.features.titles.premiumSupport",
    text: "pricingPage.features.descriptions.premiumSupport"
};
var ENTERPRISE_DASHBOARDS = {
    name: "pricingPage.features.titles.enterpriseDashboards",
    text: "pricingPage.features.descriptions.fiftyDashboards"
};
// added for marketing:
var MARKETING_TEMPLATES = {
    name: "pricingPage.features.titles.ready_made_marketing_templates",
    text: "pricingPage.features.descriptions.ready_made_marketing_templates"
};
var MARKETING_REQUESTS_WITH_FORMS = {
    name: "pricingPage.features.titles.marketing_requests_with_forms",
    text: "pricingPage.features.descriptions.marketing_requests_with_forms"
};
var UNLIMITED_TEMPLATES = {
    name: "pricingPage.features.titles.unlimited_templates",
    text: "pricingPage.features.descriptions.ready_made_marketing_templates"
};
var WORK_PERFORMANCE_INSIGHTS = {
    name: "pricingPage.features.titles.workPerformanceInsights",
    text: "pricingPage.features.descriptions.workPerformanceInsights"
};
var ASSETS_AND_FILE_MANAGEMENT = {
    name: "pricingPage.features.titles.assets_and_file_management",
    text: "pricingPage.features.descriptions.embed_documents_and_briefs"
};
var IMPORT_EXPORT_EXCEL = {
    name: "pricingPage.features.titles.import_export_excel",
    text: "pricingPage.features.descriptions.import_export_excel"
};
var SOCIAL_CALENDAR = {
    name: "pricingPage.features.titles.social_calendar",
    text: "pricingPage.features.descriptions.marketing_calendar"
};
var SHARE_INSIGHTS_WITH_GUESTS = {
    name: "pricingPage.features.titles.share_insights_with_guests",
    text: "pricingPage.features.descriptions.guests"
};
var MARKETING_ANALYTICS = {
    name: "pricingPage.features.titles.marketing_analytics",
    text: "pricingPage.features.descriptions.marketing_dashboards"
};
var DEADLINE_MANAGEMENT = {
    name: "pricingPage.features.titles.deadline_management",
    text: "pricingPage.features.descriptions.deadline_management"
};
var CAMPAIGN_MANAGEMENT = {
    name: "pricingPage.features.titles.campaign_management",
    text: "pricingPage.features.descriptions.campaign_management"
};
var HIGH_LEVEL_MARKETING_PLANNING = {
    name: "pricingPage.features.titles.high_level_marketing_planning",
    text: "pricingPage.features.descriptions.high_level_marketing_planning"
};
var ADOBE_CREATIVE_CLOUD_PLUGIN = {
    name: "pricingPage.features.titles.adobe_creative_cloud_plugin",
    text: "pricingPage.features.descriptions.adobe_creative_cloud_plugin"
};
var UNLIMITED_PROJECTS_ITEMS_SUBITEMS = {
    name: "pricingPage.features.titles.unlimitedProjectsItemsSubitems",
    text: "pricingPage.features.descriptions.unlimitedProjectsItemsSubitems"
};
var UNLIMITED_SHAREABLE_FORMS = {
    name: "pricingPage.features.titles.unlimitedShareableForms",
    text: "pricingPage.features.descriptions.unlimitedShareableForms"
};
var FILE_MANAGEMENT = {
    name: "pricingPage.features.titles.fileManagement",
    text: "pricingPage.features.descriptions.fileManagement"
};
var GANTT_CHARTS = {
    name: "pricingPage.features.titles.ganttCharts",
    text: "pricingPage.features.descriptions.ganttCharts"
};
var CUSTOM_NOTIFICATIONS_AND_REMINDERS = {
    name: "pricingPage.features.titles.customNotificationsAndReminders",
    text: "pricingPage.features.descriptions.customNotificationsAndReminders"
};
var SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT = {
    name: "pricingPage.features.titles.projectPortfolioManagement",
    text: "pricingPage.features.descriptions.projectPortfolioManagement"
};
var CALENDAR_SYNC = {
    name: "pricingPage.features.titles.calendarSync",
    text: "pricingPage.features.descriptions.calendarSync"
};
var BASIC_ANALYTICS_AND_DASHBOARDS = {
    name: "pricingPage.features.titles.basicAnalytics",
    text: "pricingPage.features.descriptions.basicAnalytics"
};
var TASK_AND_PROJECT_DEPENDENCIES = {
    name: "pricingPage.features.titles.taskAndProjectDependencies",
    text: "pricingPage.features.descriptions.taskAndProjectDependencies"
};
var MILESTONES_MANAGEMENT = {
    name: "pricingPage.features.titles.milestonesManagement",
    text: "pricingPage.features.descriptions.milestonesManagement"
};
var RESOURCE_ALLOCATION = {
    name: "pricingPage.features.titles.resourceAllocation",
    text: "pricingPage.features.descriptions.resourceAllocation"
};
var POWERFUL_ANALYTICS_AND_DASHBOARDS = {
    name: "pricingPage.features.titles.powerfulAnalytics",
    text: "pricingPage.features.descriptions.powerfulAnalytics"
};
var UNLIMITED_PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.unlimitedPrivateBoards",
    text: "pricingPage.features.descriptions.privateBoards"
};
var ADVANCED_FORMULA_CAPABILITIES = {
    name: "pricingPage.features.titles.advancedFormulaCapabilities",
    text: "pricingPage.features.descriptions.formula"
};
var SLACK_MSTEAMS_TODOIST_INTEGRATIONS = {
    name: "pricingPage.features.titles.slackMSTeamsTodoistIntegrations",
    text: "pricingPage.features.descriptions.slackMSTeamsTodoistIntegrations"
};
var ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT = {
    name: "pricingPage.features.titles.advancedProjectPortfolioManagement",
    text: "pricingPage.features.descriptions.advancedProjectPortfolioManagement"
};
var ENTERPRISE_INTEGRATIONS = {
    name: "pricingPage.features.titles.enterpriseIntegrations",
    text: "pricingPage.features.descriptions.enterpriseIntegrations"
};
var SPRINT_MANAGEMENT = {
    name: "pricingPage.features.titles.sprint_management",
    text: "pricingPage.features.descriptions.sprint_management"
};
var KANBAN_MANAGEMENT = {
    name: "pricingPage.features.titles.kanban_management",
    text: "pricingPage.features.descriptions.kanban_management"
};
var DEV_TEMPLATES = {
    name: "pricingPage.features.titles.dev_templates",
    text: "pricingPage.features.descriptions.dev_templates"
};
var BUILT_IN_WORKOCS = {
    name: "pricingPage.features.titles.workdocs",
    text: "pricingPage.features.descriptions.workdocs"
};
var SHARABLE_DEV_BOARDS = {
    name: "pricingPage.products.software.featuresList.shareableBoardsWithExternalStakeholders",
    text: "pricingPage.products.software.featuresList.shareableBoardsWithExternalStakeholders.description"
};
var GIT_INTEGRATIONS = {
    name: "pricingPage.features.titles.git_integrations",
    text: "pricingPage.features.descriptions.git_integrations"
};
var AGILE_REPORTING = {
    name: "pricingPage.features.titles.agile_reporting",
    text: "pricingPage.features.descriptions.agile_reporting"
};
var DEV_FEEDBACK_FORMS = {
    name: "pricingPage.products.software.featuresList.customerFeedbackAndRequests",
    text: "pricingPage.products.software.featuresList.customerFeedbackAndRequests.description"
};


/***/ }),

/***/ 16168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K8": function() { return /* binding */ SECURITY_AND_PRIVACY; },
/* harmony export */   "Kk": function() { return /* binding */ CUSTOMER_FAVORITES; },
/* harmony export */   "QA": function() { return /* binding */ SUPPORT_NEW; },
/* harmony export */   "RV": function() { return /* binding */ REMOTE_WORK_FEATURES_SECTION; },
/* harmony export */   "UO": function() { return /* binding */ ADVANCED; },
/* harmony export */   "VG": function() { return /* binding */ getDefaultSections; },
/* harmony export */   "Xn": function() { return /* binding */ ADMINISTRATION_AND_CONTROL; },
/* harmony export */   "_h": function() { return /* binding */ SECURITY_NEW; },
/* harmony export */   "iz": function() { return /* binding */ COLLABORATION; },
/* harmony export */   "k3": function() { return /* binding */ ADVANCED_REPORTING; },
/* harmony export */   "lG": function() { return /* binding */ SECURITY; },
/* harmony export */   "nD": function() { return /* binding */ PRODUCTIVITY; },
/* harmony export */   "uK": function() { return /* binding */ VIEWS_AND_REPORTING; },
/* harmony export */   "wL": function() { return /* binding */ SUPPORT; },
/* harmony export */   "zw": function() { return /* binding */ ENTERPRISE_REPORTING_AND_ANALYTICS; }
/* harmony export */ });
/* unused harmony export NEW_PRICING_PAGE_DEFAULT_SECTIONS */
/* harmony import */ var _features_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61980);

var CUSTOMER_FAVORITES = function(param) {
    var hasStudentPlan = param.hasStudentPlan, cookies = param.cookies;
    return {
        sectionName: "pricingPage.features.sections.customer_favorites",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TEMPLATES,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.COLUMN_TYPES({
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.IMPORT_FROM_OTHER_TOOLS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS
        ]
    };
};
var COLLABORATION = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasFreeTier = param.hasFreeTier, hasStudentPlan = param.hasStudentPlan;
    var featuresList = [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMBEDDED_BOARD,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WHITEBOARD,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.UPDATES_SECTION,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ZOOM_INTEGRATION,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GUESTS
    ];
    if (!(hasFreeTier || hasStudentPlan)) {
        // otherwise, the following features already appear via the 'ESSENTIALS' section.
        featuresList.unshift(_features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS);
        featuresList.push(_features_features__WEBPACK_IMPORTED_MODULE_0__.STORAGE({
            cookies: cookies,
            abTests: abTests
        }));
    }
    return {
        sectionName: "pricingPage.features.sections.collaboration",
        features: featuresList
    };
};
var PRODUCTIVITY = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.productivity",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CUSTOMIZABLE_NOTIFICATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PREMIUM_INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIME_TRACKING,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DEPENDENCY_COLUMN
        ]
    };
};
var VIEWS_AND_REPORTING = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.views_and_reporting",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ACTIVITY_LOG,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DASHBOARDS({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.KANBAN_VIEW,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CALENDAR({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAP,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WORKLOAD
        ]
    };
};
// Newest, winning version.
var SUPPORT_NEW = {
    sectionName: "pricingPage.features.sections.support",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.KNOWLEDGE_BASE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMAIL_SUPPORT,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WEBINARS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CS_MANAGER,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SLA
    ]
};
// New, winning version.
var SECURITY_AND_PRIVACY = {
    sectionName: "pricingPage.features.sections.security_and_privacy",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SOC,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.IP_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CONTENT_DIRECTORY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TEAMS_INSIDE_TEAMS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CUSTOM_ROLES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SEATS_MANAGEMENT,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TENANT_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.APPROVED_GUEST,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.BLOCK_DOMAINS
    ]
};
var ADMINISTRATION_AND_CONTROL = {
    sectionName: "pricingPage.features.sections.administration_and_control",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.MAXIMUM_SEATS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.BOARD_ADMINISTRATORS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCIM,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.AUDIT_LOG,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SESSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PANIC_MODE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_WORKSPACES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ACCOUNT_PERMISSIONS
    ]
};
var ENTERPRISE_REPORTING_AND_ANALYTICS = {
    sectionName: "pricingPage.features.sections.enterprise_reporting_and_analytics",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WORK_PERFORMANCE_INSIGHTS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCHEDULED_DASHBOARD_DELIVERY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PIVOT_ANALYSIS
    ]
};
var NEW_PRICING_PAGE_DEFAULT_SECTIONS = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return [
        CUSTOMER_FAVORITES({
            hasStudentPlan: hasStudentPlan,
            cookies: cookies
        }),
        COLLABORATION({
            cookies: cookies,
            abTests: abTests,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        }),
        PRODUCTIVITY({
            hasStudentPlan: hasStudentPlan
        }),
        VIEWS_AND_REPORTING({
            hasStudentPlan: hasStudentPlan
        }),
        SUPPORT_NEW,
        SECURITY_AND_PRIVACY,
        ADMINISTRATION_AND_CONTROL,
        ENTERPRISE_REPORTING_AND_ANALYTICS
    ];
};
var REMOTE_WORK_FEATURES_SECTION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.remote_work",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WHITEBOARD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.EMBEDDED_BOARD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ZOOM_INTEGRATION,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CALENDAR({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
var ADVANCED = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.advanced",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.GUESTS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.KANBAN_VIEW,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAP,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.SEARCH,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS_CUSTOMIZATION({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WORKLOAD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIME_TRACKING,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DEPENDENCY_COLUMN,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TAGS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PREMIUM_INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DASHBOARDS({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
// Old version, before any tests. Kept here until we're 100% sure none of the clusters use it.
var SECURITY = {
    sectionName: "pricingPage.features.sections.security",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCIM,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.AUDIT_LOG,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SESSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SLA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_WORKSPACES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ACCOUNT_PERMISSIONS
    ]
};
var ADVANCED_REPORTING = {
    sectionName: "pricingPage.features.sections.advancedReporting",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WORK_PERFORMANCE_INSIGHTS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCHEDULED_DASHBOARD_DELIVERY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PIVOT_ANALYSIS
    ]
};
// Old version, kept until we're certain none of the clusters use it.
var SUPPORT = {
    sectionName: "pricingPage.features.sections.support",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.KNOWLEDGE_BASE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMAIL_SUPPORT,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TAILORED_ONBOARDING
    ]
};
// Newer version, of a successful test.
var SECURITY_NEW = {
    sectionName: "pricingPage.features.sections.security_new",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SOC,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.IP_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CONTENT_DIRECTORY
    ]
};
var getDefaultSections = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return NEW_PRICING_PAGE_DEFAULT_SECTIONS({
        cookies: cookies,
        abTests: abTests,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
};


/***/ }),

/***/ 8876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ getFreeTierEssentials; }
/* harmony export */ });
/* harmony import */ var _features_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61980);

var getFreeTierEssentials = function(abTests, cookies) {
    return {
        sectionName: "pricingPage.features.sections.essentials",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAXIMUM_SEATS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ITEMS({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.STORAGE({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ACTIVITY_LOG,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_BOARDS_WITH_FREE_TIER({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_DOCS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.COLUMN_TYPES({
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TEMPLATES,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS
        ]
    };
};


/***/ }),

/***/ 87529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getDefaultTierDescriptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}

var _obj;
var DEFAULT_TIER_DESCRIPTIONS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, "pricingPage.tierDescriptions.individual.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, "pricingPage.tierDescriptions.basic.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, "pricingPage.tierDescriptions.standard.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, "pricingPage.tierDescriptions.pro.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, "pricingPage.tierDescriptions.enterprise.new"), _obj);
var getDefaultTierDescriptions = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var tierDescriptions = _object_spread({}, DEFAULT_TIER_DESCRIPTIONS);
    if (hasStudentPlan) {
        tierDescriptions[constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE] = "pricingPage.tierDescriptions.student";
    }
    return tierDescriptions;
};


/***/ }),

/***/ 69078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ DEFAULT_VALUE_FEATURES_PER_TIER; },
/* harmony export */   "v": function() { return /* binding */ getDefaultValueFeatures; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78217);
/* harmony import */ var services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46724);




var DEFAULT_VALUE_FEATURES_PER_TIER = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var withoutBasic = (0,services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__/* .shouldHideBasic */ .gd)({
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, hasStudentPlan ? _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .STUDENT_PLAN_VALUE_FEATURES */ .b5 : (0,services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__/* .getFreeTierFeaturesByAbTest */ .EF)({
        cookies: cookies,
        forcePricing: forcePricing
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, (0,_features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .BASIC_TIER_VALUE_FEATURES */ .cN)({
        hasFreeTier: hasFreeTier
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, (0,_features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .STANDARD_TIER_VALUE_FEATURES */ .kh)({
        withoutBasic: withoutBasic,
        hasFreeTier: hasFreeTier
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .PRO_TIER_VALUE_FEATURES */ .tE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .ENTERPRISE_TIER_VALUE_FEATURES */ .$4), _obj;
};
var getDefaultValueFeatures = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    return DEFAULT_VALUE_FEATURES_PER_TIER({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
};


/***/ }),

/***/ 46724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ enterV13TestIfNeeded; },
  "EF": function() { return /* binding */ getFreeTierFeaturesByAbTest; },
  "FW": function() { return /* binding */ getFreeTierSeatsCountByAbTest; },
  "_n": function() { return /* binding */ getIsFreeOver20ColumnTypes; },
  "J6": function() { return /* binding */ getIsUnlimitedBoards; },
  "gd": function() { return /* binding */ shouldHideBasic; },
  "GV": function() { return /* binding */ shouldSeeProductsPricingPage; },
  "fy": function() { return /* binding */ shouldSeeV10PricingVersion; },
  "H6": function() { return /* binding */ shouldShowPricingSubTitleV2; },
  "u0": function() { return /* binding */ shouldShowPurchaseNow; },
  "Ce": function() { return /* binding */ shouldShowTalkToSalesCta; },
  "RT": function() { return /* binding */ shouldShowTypeformContactUs; }
});

// UNUSED EXPORTS: shouldSeeV11PricingVersion, shouldSeeV12PricingVersion, shouldSeeV13PricingVersion

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/new-ab-tests.js
var new_ab_tests = __webpack_require__(60734);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
var pricing_versions_default = /*#__PURE__*/__webpack_require__.n(pricing_versions);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_feature_collections.js
var value_feature_collections = __webpack_require__(78217);
;// CONCATENATED MODULE: ./constants/monetization-ab-tests.ts
var PURCHASE_NOW_AB_TEST = {
    test_name: "purchase_now_ab_test",
    new_variation_name: "new_with_purchase_now_button"
};
var PRICING_SUB_TITLE_V2_AB_TEST = {
    test_name: "pricing_page_sub_title_v2_ab_test",
    new_variation_name: "new_pricing_with_sub_title_v2"
};
var HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST = {
    test_name: "homepage_platform_pricing_contact_us_cta_ab_test",
    new_variation_name: "new_cta_with_talk_to_sales"
};
var HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG = {
    test_name: "homepage_pricing_enterprise_contact_us_typeform_feature_flag",
    new_variation_name: "new_homepage_pricing_enterprise_contact_us_typeform_feature_flag"
};

;// CONCATENATED MODULE: ./constants/force-pricing.ts
var PRICING_SUB_TITLE_V2 = "sub_title_v2";
var FORCE_TALK_TO_SALES = "talk_to_sales";

// EXTERNAL MODULE: ./utils/mobile.js
var mobile = __webpack_require__(34955);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_features.js
var value_features = __webpack_require__(49127);
;// CONCATENATED MODULE: ./services/ab-tests/monetization-ab-tests-service.js












var shouldHideBasic = function(param) {
    var abTests = param.abTests, forcePricing = param.forcePricing, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan;
    if (hasStudentPlan) return true; // First we check if we're in student plan mode - in this mode we don't show the basic tier
    var ref = cookies || {}, platformCookieValue = ref[constants_cookies.PLATFORM_HIDE_BASIC_COOKIE]; // The visitor might have came from the platform before, so we check if we hide basic in the platform
    if (platformCookieValue) return platformCookieValue === "true";
    if (forcePricing === "without_basic") return true; // We want to test it by ourselves so we use force_pricing query param.
    return (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_HIDE_BASIC_AB_TEST.test_name) === new_ab_tests.HOMEPAGE_HIDE_BASIC_AB_TEST.new_variation_name;
};
var shouldSeeProductsPricingPage = function(param) {
    var forcePricing = param.forcePricing;
    return forcePricing === "products";
};
var shouldSeeV10PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === "v10") return true;
    var platformCookie = cookies[constants_cookies.PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === (pricing_versions_default()).VERSION_10;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_V10_PRICING_VERSION_AB_TEST.test_name);
    return abTestVariant === new_ab_tests.HOMEPAGE_V10_PRICING_VERSION_AB_TEST.new_variation_name;
};
var shouldSeeV11PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing, currency = param.currency;
    if (forcePricing === "v11") return true;
    var platformCookie = cookies[PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === PricingVersions.VERSION_11;
    if (currency === "jpy") return true;
    return false;
};
var shouldSeeV13PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing, isV13PricingVersion = param.isV13PricingVersion;
    if (forcePricing === PricingVersions.VERSION_13) return true;
    var platformCookie = cookies[PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === PricingVersions.VERSION_13;
    var homepageCookie = cookies[HOMEPAGE_PRICING_VERSION_COOKIE];
    if (homepageCookie) return homepageCookie === PricingVersions.VERSION_13;
    if (isV13PricingVersion) return true; // For testing
    var abTestVariant = getAbTestVariantNew(abTests, HOMEPAGE_V13_PRICING_VERSION_AB_TEST.test_name);
    return abTestVariant === HOMEPAGE_V13_PRICING_VERSION_AB_TEST.new_variation_name;
};
var enterV13TestIfNeeded = function(abTests, cookies, forcePricing, isV13PricingVersion) {
    if (cookies === null || cookies === void 0 ? void 0 : cookies[constants_cookies.PLATFORM_PRICING_VERSION_COOKIE]) return;
    if (forcePricing) return;
    // Report to Bigbrain that the user entered the test
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_V13_PRICING_VERSION_AB_TEST.test_name, true);
    if (isV13PricingVersion || abTestVariant === new_ab_tests.HOMEPAGE_V13_PRICING_VERSION_AB_TEST.new_variation_name) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(constants_cookies.HOMEPAGE_PRICING_VERSION_COOKIE, (pricing_versions_default()).VERSION_13, {
            expires: 90
        });
    } else {
        (0,cookies_service/* setCookieIfNeeded */.cr)(constants_cookies.HOMEPAGE_PRICING_VERSION_COOKIE, (pricing_versions_default()).DEFAULT_VERSION, {
            expires: 90
        });
    }
};
var shouldSeeV12PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === PricingVersions.VERSION_12) return true;
    var platformCookie = cookies[PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === PricingVersions.VERSION_12;
    var homepageCookie = cookies[HOMEPAGE_PRICING_VERSION_COOKIE];
    if (homepageCookie) return homepageCookie === PricingVersions.VERSION_12;
    var abTestVariant = getAbTestVariantNew(abTests, HOMEPAGE_V12_PRICING_VERSION_AB_TEST.test_name);
    return abTestVariant === HOMEPAGE_V12_PRICING_VERSION_AB_TEST.new_variation_name;
};
var getFreeTierVersion = function(cookies, forcePricing) {
    var platformCookie = cookies[constants_cookies.PLATFORM_FREE_TIER_VERSION_COOKIE];
    var forceFreeTierVersion = forcePricing || platformCookie;
    var _obj;
    var variantToVersion = (_obj = {}, (0,_define_property/* default */.Z)(_obj, new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_b, "2022_a"), (0,_define_property/* default */.Z)(_obj, new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_c, "2022_b"), _obj);
    var freeTierVersion = forceFreeTierVersion || variantToVersion[new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_b];
    return freeTierVersion;
};
var getFreeTierFeaturesByAbTest = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return [
                value_features.UP_TO_THREE_BOARDS,
                value_features.UNLIMITED_DOCS,
                value_features.OVER_200_TEMPLATES,
                value_features.LIMITED_COLUMN_TYPES,
                value_features.UP_TO_X_TEAM_MEMBERS(pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3),
                value_features.MOBILE
            ];
        case "2022_b":
            return [
                value_features.UP_TO_THREE_BOARDS,
                value_features.UNLIMITED_DOCS,
                value_features.OVER_200_TEMPLATES,
                value_features.LIMITED_COLUMN_TYPES,
                value_features.UP_TO_X_TEAM_MEMBERS(pricing/* FREE_TIER_2022_SEATS_LIMIT */.no),
                value_features.MOBILE
            ];
        default:
            return value_feature_collections/* FREE_TIER_VALUE_FEATURES */.tL;
    }
};
var getFreeTierSeatsCountByAbTest = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3;
        case "2022_b":
            return pricing/* FREE_TIER_2022_SEATS_LIMIT */.no;
        default:
            return pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3;
    }
};
var getIsFreeOver20ColumnTypes = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return false;
        case "2022_b":
            return false;
        default:
            return true;
    }
};
var getIsUnlimitedBoards = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return false;
        case "2022_b":
            return false;
        default:
            return true;
    }
};
var shouldShowPurchaseNow = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === "purchase_now") return true;
    if ((0,mobile/* isMobile */.tq)()) return false;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, PURCHASE_NOW_AB_TEST.test_name, true);
    return abTestVariant === PURCHASE_NOW_AB_TEST.new_variation_name;
};
var shouldShowPricingSubTitleV2 = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === PRICING_SUB_TITLE_V2) return true;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, PRICING_SUB_TITLE_V2_AB_TEST.test_name, true);
    return abTestVariant === PRICING_SUB_TITLE_V2_AB_TEST.new_variation_name;
};
var shouldShowTalkToSalesCta = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === FORCE_TALK_TO_SALES) return true;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST.test_name, true);
    return abTestVariant === HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST.new_variation_name;
};
var shouldShowTypeformContactUs = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG.test_name, true);
    return abTestVariant === HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG.new_variation_name;
};


/***/ }),

/***/ 15650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c0": function() { return /* binding */ getCurrencyName; },
  "hU": function() { return /* binding */ getCurrencySign; },
  "$H": function() { return /* binding */ getCurrencyWithPriceDisplay; },
  "j": function() { return /* binding */ shouldSeeContactUs; }
});

// UNUSED EXPORTS: AUD_COUNTRIES, CAD_COUNTRIES, EURO_COUNTRIES, GBP_COUNTRIES, JPY_COUNTRIES, PESO_COUNTRIES, REAL_COUNTRIES, USD_CURRENCY, getCurrencyData, getCurrencyShortText, setCurrencyCookie

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing/price-with-currency/price-with-currency.scss.js

var StyledPriceWithCurrency = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "esqe350"
})("display:flex;align-items:flex-end;.currency-sign-and-text{display:inline-flex;flex-direction:column;align-items:center;margin-right:2%;margin-bottom:3%;.currency-sign{font-size:0.65em;}.currency-text{font-size:0.2em;font-weight:bold;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing/price-with-currency/price-with-currency.js



var PriceWithCurrency = function(param) {
    var price = param.price, currency = param.currency, currencySign = param.currencySign, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceWithCurrency, {
        className: "price-with-currency",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "currency-sign-and-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("currency-sign", className),
                        children: currencySign
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("currency-text", className),
                        children: currency.toUpperCase()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: className,
                children: price
            })
        ]
    });
};
/* harmony default export */ var price_with_currency = (PriceWithCurrency);

;// CONCATENATED MODULE: ./services/pricing-service.js







var CURRENCY_SIGN_RIGHT_OF_NUMBER_LOCALES = [
    localization.FRENCH_LOCALE_ID,
    localization.GERMAN_LOCALE_ID
];
var USD_CURRENCY = "usd";
var EURO_COUNTRIES = [
    "ad",
    "at",
    "be",
    "cy",
    "ee",
    "fi",
    "fr",
    "de",
    "gr",
    "ie",
    "it",
    "lv",
    "lt",
    "lu",
    "mt",
    "mc",
    "me",
    "nl",
    "pt",
    "sm",
    "sk",
    "si",
    "es",
    // NEW - starting from Jul 2022
    "al",
    "bh",
    "by",
    "ba",
    "bg",
    "hr",
    "cz",
    "dk",
    "eg",
    "fo",
    "ge",
    "gi",
    "hu",
    "is",
    "jo",
    "kw",
    "li",
    "mk",
    "md",
    "ma",
    "no",
    "om",
    "pl",
    "qa",
    "ro",
    "rs",
    "se",
    "ch",
    "sa",
    "tn",
    "tr",
    "ug",
    "ua",
    "ae",
    "va",
    "ye" // Yemen
];
var GBP_COUNTRIES = [
    "gb",
    "je",
    "gg",
    "im",
    "gs",
    "uk" // United Kingdom
];
var CAD_COUNTRIES = [
    "ca" // Canada
];
var AUD_COUNTRIES = [
    "au" // Australia
];
var PESO_COUNTRIES = [
    "mx" // Mexico
];
var REAL_COUNTRIES = [
    "br" // Brazil
];
var JPY_COUNTRIES = [
    "jp" // Japan
];
var CONTACT_US_THRESHOLD = 50;
var setCurrencyCookie = function setCurrencyCookie(currencyShortText) {
    (0,cookies_service/* setCookie */.d8)(cookies.CURRENCY_COOKIE_NAME, currencyShortText);
};
var getCurrencyFromCountry = function(country) {
    if (country) {
        var countryCode = country.toLowerCase();
        if (EURO_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("eur");
            return "eur";
        }
        if (GBP_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("gbp");
            return "gbp";
        }
        if (CAD_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("cad");
            return "cad";
        }
        if (AUD_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("aud");
            return "aud";
        }
        if (PESO_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("mxn");
            return "mxn";
        }
        if (REAL_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("brl");
            return "brl";
        }
        if (JPY_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("jpy");
            return "jpy";
        }
        //default to usd
        setCurrencyCookie("usd");
        return "usd";
    } else {
        //no country cookie - we return undefined and rely on the default configuration file
        //TODO: log an error? we are server side.
        return undefined;
    }
};
var getCurrency = function(forceCurrencyShortText, pricingDefaults, countryCode) {
    // first check query param exists.
    if (forceCurrencyShortText) {
        return forceCurrencyShortText;
    }
    if (countryCode) {
        return getCurrencyFromCountry(countryCode);
    }
    return (pricingDefaults === null || pricingDefaults === void 0 ? void 0 : pricingDefaults.defaultCurrency) || USD_CURRENCY;
};
var getCurrencyData = function getCurrencyData(currency) {
    var currenciesArray = pricing/* SUPPORTED_CURRENCIES.filter */.ck.filter(function(currencyItem) {
        //find not supported in ie
        return currencyItem.name === currency;
    });
    return currenciesArray[0];
};
var getCurrencyShortText = function getCurrencyShortText(currency) {
    var currencyData = getCurrencyData(currency);
    if (currencyData.shouldDisplayText) {
        return currencyData.currencyShortText;
    }
    return null;
};
var getCurrencyName = function(param) {
    var forceCurrency = param.forceCurrency, _pricingDefaults = param.pricingDefaults, pricingDefaults = _pricingDefaults === void 0 ? {} : _pricingDefaults, countryCode = param.countryCode;
    var shortCurrencyText = getCurrency(forceCurrency, pricingDefaults, countryCode);
    var currencyArray = pricing/* SUPPORTED_CURRENCIES.filter */.ck.filter(function(supportedCurrency) {
        //find not supported in ie
        return supportedCurrency.currencyShortText.toLowerCase() === shortCurrencyText.toLowerCase();
    });
    return currencyArray[0].name;
};
var getCurrencySign = function getCurrencySign(currency) {
    var currencyData = getCurrencyData(currency);
    return currencyData.currencySign;
};
var shouldShowCurrencyText = function(currency) {
    var lowerCaseCurrency = currency.toLowerCase();
    switch(lowerCaseCurrency){
        case "cad":
        case "aud":
        case "mxn":
            return true;
        default:
            return false;
    }
};
// For some locales, the currency sign (e.g. $) comes to the right of the price value.
var getCurrencyWithPriceDisplay = function(param) {
    var price = param.price, currency = param.currency, _localeId = param.localeId, localeId = _localeId === void 0 ? localization.ENGLISH_LOCALE_ID : _localeId, _hideCurrency = param.hideCurrency, hideCurrency = _hideCurrency === void 0 ? false : _hideCurrency, className = param.className;
    if (hideCurrency) {
        return price;
    }
    var currencySign = getCurrencySign(currency);
    var shouldShowCurrencyToTheRight = CURRENCY_SIGN_RIGHT_OF_NUMBER_LOCALES.includes(localeId);
    if (!hideCurrency && shouldShowCurrencyText(currency)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(price_with_currency, {
            price: price,
            currency: currency,
            currencySign: currencySign,
            className: className
        });
    }
    return shouldShowCurrencyToTheRight ? "".concat(price, " ").concat(currencySign) : "".concat(currencySign).concat(price);
};
var getContactUsThreshold = function(param) {
    var clusterConfig = param.clusterConfig, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    if (!(0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) return CONTACT_US_THRESHOLD;
    return (clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.contact_us_threshold) || CONTACT_US_THRESHOLD;
};
var shouldSeeContactUs = function shouldSeeContactUs(tier, usersCount) {
    var contactUsThresholdOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return tier === pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE || usersCount.includes("+") || Number(usersCount) >= getContactUsThreshold(contactUsThresholdOptions);
};


/***/ }),

/***/ 12403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CF": function() { return /* binding */ applyFreeUsersIfNeeded; },
/* harmony export */   "KX": function() { return /* binding */ applyDiscountIfNeeded; },
/* harmony export */   "pZ": function() { return /* binding */ shouldHideCrossedOutPrice; },
/* harmony export */   "qV": function() { return /* binding */ getMaxFreeUsersFromClusterConfig; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69017);



var getDiscountFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var discount = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.discount;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return discount;
    }
};
var getFreeUsersFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing_users_count_options, _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var freeOptions = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : (_clusterConfig_payments_view_pricing_users_count_options = _clusterConfig_payments_view_pricing.users_count_options) === null || _clusterConfig_payments_view_pricing_users_count_options === void 0 ? void 0 : _clusterConfig_payments_view_pricing_users_count_options.free_options;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(freeOptions) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return freeOptions;
    }
};
var getMaxFreeUsersFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var freeOptions = getFreeUsersFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if ((freeOptions === null || freeOptions === void 0 ? void 0 : freeOptions.length) > 0) {
        var _Math;
        return (_Math = Math).max.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(freeOptions));
    }
};
var applyDiscountIfNeeded = function(price, tier, period, clusterConfig, abTests, cookies, forcePricing) {
    var discount = getDiscountFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount)) return price;
    var value = discount.value, validTiers = discount.valid_tiers, validPeriods = discount.valid_periods;
    if (!value) return price;
    var isValidTier = lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(validTiers) || validTiers.includes(tier);
    var isValidPeriod = lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(validPeriods) || validPeriods.includes(period);
    var isDiscountValidForPlan = isValidTier && isValidPeriod;
    if (!isDiscountValidForPlan) return price;
    return price * (1 - value);
};
var applyFreeUsersIfNeeded = function(price, initialUsersCount, clusterConfig, abTests, cookies, forcePricing) {
    var usersCount = initialUsersCount;
    var maxFreeUsers = getMaxFreeUsersFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if (maxFreeUsers > 0) {
        usersCount = initialUsersCount - maxFreeUsers;
    }
    return Math.max(price * usersCount, 0);
};
var shouldHideCrossedOutPrice = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var discount = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.discount;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return discount.hide_crossed_out_discount;
    }
    return false;
};


/***/ }),

/***/ 70533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ shouldShowYearlyPrices; },
/* harmony export */   "K": function() { return /* binding */ getPeriods; }
/* harmony export */ });
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69017);



var getClusterPeriodsConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var periods = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.periods;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(periods) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_2__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return periods;
    }
    return {};
};
var getPeriods = function(clusterConfig, abTests, cookies, forcePricing) {
    var periods = constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .ORDERED_PERIOD_NAMES */ .yv;
    var clusterPeriodsConfig = getClusterPeriodsConfig(clusterConfig, abTests, cookies, forcePricing);
    var ref = clusterPeriodsConfig || {}, tmp = ref.hidden_periods, hiddenPeriods = tmp === void 0 ? [] : tmp;
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(hiddenPeriods) ? periods : periods.filter(function(period) {
        return !hiddenPeriods.includes(period);
    });
};
var shouldShowYearlyPrices = function(clusterConfig, abTests, cookies, forcePricing) {
    var clusterPeriodsConfig = getClusterPeriodsConfig(clusterConfig, abTests, cookies, forcePricing);
    var display = clusterPeriodsConfig.display;
    return (display === null || display === void 0 ? void 0 : display.price_display) === constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .PERIODS.yearly */ .z5.yearly;
};


/***/ }),

/***/ 3223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xS": function() { return /* binding */ getPricingModelService; },
  "rM": function() { return /* binding */ getPricingVersion; },
  "qM": function() { return /* binding */ getPricingVersionForSales; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
var pricing_versions_default = /*#__PURE__*/__webpack_require__.n(pricing_versions);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./services/pricing/discounts-service.js
var discounts_service = __webpack_require__(12403);
// EXTERNAL MODULE: ./services/pricing/periods-service.js
var periods_service = __webpack_require__(70533);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/base-pricing-model-service.js





var BasePricingModelService = /*#__PURE__*/ function() {
    "use strict";
    function BasePricingModelService() {
        (0,_class_call_check/* default */.Z)(this, BasePricingModelService);
    }
    (0,_create_class/* default */.Z)(BasePricingModelService, [
        {
            key: "getPlanPrice",
            value: function getPlanPrice(tier, currency, billingPeriod, userCount, pricingVersion, clusterConfig, abTests, cookies, forcePricing) {
                var hideDiscount = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : false;
                var prices = this.getPrices({
                    pricingVersion: pricingVersion
                });
                if (tier === pricing/* TIERS.FREE */.Iy.FREE) return 0;
                var basePrice = (0,discounts_service/* applyFreeUsersIfNeeded */.CF)(prices[billingPeriod][tier][currency], userCount, clusterConfig, abTests, cookies, forcePricing);
                var price = (0,periods_service/* shouldShowYearlyPrices */.B)(clusterConfig, abTests, cookies, forcePricing) ? basePrice * 12 : basePrice;
                return hideDiscount ? price : (0,discounts_service/* applyDiscountIfNeeded */.KX)(price, tier, billingPeriod, clusterConfig, abTests, cookies, forcePricing);
            }
        },
        {
            key: "shouldShowUserOptions",
            value: function shouldShowUserOptions() {
                return true;
            }
        },
        {
            key: "getDefaultUserOption",
            value: function getDefaultUserOption() {
                return "0";
            }
        },
        {
            key: "getUserOptions",
            value: function getUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return {};
            }
        },
        {
            key: "getPrices",
            value: function getPrices() {
                return [];
            }
        }
    ]);
    return BasePricingModelService;
}();


// EXTERNAL MODULE: ./services/pricing/product-prices.js
var product_prices = __webpack_require__(43331);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/buckets-pricing-model-service.js










var BucketsPricingModelService = /*#__PURE__*/ function(BasePricingModelService) {
    "use strict";
    (0,_inherits/* default */.Z)(BucketsPricingModelService, BasePricingModelService);
    var _super = (0,_create_super/* default */.Z)(BucketsPricingModelService);
    function BucketsPricingModelService() {
        (0,_class_call_check/* default */.Z)(this, BucketsPricingModelService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BucketsPricingModelService, [
        {
            key: "shouldShowUserOptions",
            value: function shouldShowUserOptions() {
                return true;
            }
        },
        {
            key: "getClusterUserOptions",
            value: function getClusterUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
                var clusterConfig = options.clusterConfig, abTests = options.abTests, forcePricing = options.forcePricing, cookies = options.cookies;
                var users_count_options = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.users_count_options;
                if (!isEmpty_default()(clusterConfig) && (0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
                    abTests: abTests,
                    forcePricing: forcePricing,
                    cookies: cookies
                })) {
                    return users_count_options === null || users_count_options === void 0 ? void 0 : users_count_options.all_options;
                }
            }
        },
        {
            key: "getDefaultUserOption",
            value: function getDefaultUserOption() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var clusterUserOptions = this.getClusterUserOptions(options);
                if ((clusterUserOptions === null || clusterUserOptions === void 0 ? void 0 : clusterUserOptions.length) > 0) return clusterUserOptions[0];
                return "3";
            }
        },
        {
            key: "getUserOptions",
            value: function getUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var clusterUserOptions = this.getClusterUserOptions(options);
                if ((clusterUserOptions === null || clusterUserOptions === void 0 ? void 0 : clusterUserOptions.length) > 0) return clusterUserOptions;
                return [
                    "3",
                    "5",
                    "10",
                    "15",
                    "20",
                    "25",
                    "30",
                    "40",
                    "50",
                    "100",
                    pricing/* MAX_TEAM_SIZE */.fY
                ];
            }
        },
        {
            key: "getPrices",
            value: function getPrices(param) {
                var _pricingVersion = param.pricingVersion, pricingVersion = _pricingVersion === void 0 ? (pricing_versions_default()).DEFAULT_VERSION : _pricingVersion;
                return product_prices/* productPrices.core */.A.core[pricingVersion];
            }
        }
    ]);
    return BucketsPricingModelService;
}(BasePricingModelService);


// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/services.js




var getPricingModelService = function(pricingVersion) {
    var _obj;
    var pricingModelsModelsMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, (pricing_versions_default()).VERSION_9, BucketsPricingModelService), (0,_define_property/* default */.Z)(_obj, (pricing_versions_default()).VERSION_13, BucketsPricingModelService), _obj);
    var PricingModelService = pricingModelsModelsMapping[pricingVersion] || pricingModelsModelsMapping[(pricing_versions_default()).DEFAULT_VERSION];
    return new PricingModelService();
};
var getPricingVersion = function() {
    var forcePricing = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).forcePricing;
    if (forcePricing) {
        var forcePricingVersionNumberArray = forcePricing.match(/\d+(?:\.\d+)?/g);
        if (forcePricingVersionNumberArray.length > 0) {
            var forcePricingVersionNumber = forcePricingVersionNumberArray[0];
            if (pricing_versions_default().ALLOWED_VERSIONS.includes("".concat(forcePricingVersionNumber))) {
                return forcePricing;
            }
        }
    }
    return (pricing_versions_default()).DEFAULT_VERSION;
};
var getPricingVersionForSales = function(param) {
    var forcePricing = param.forcePricing, cookies = param.cookies, abTests = param.abTests, forceCurrency = param.forceCurrency, countryCode = param.countryCode;
    var currency = (0,pricing_service/* getCurrencyName */.c0)({
        forceCurrency: forceCurrency,
        countryCode: countryCode
    });
    return getPricingVersion({
        forcePricing: forcePricing,
        cookies: cookies,
        abTests: abTests,
        currency: currency
    });
};


/***/ }),

/***/ 85920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ getFirstTranslatedString; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "LZ": function() { return /* binding */ EMPTY_ARRAY; },
/* harmony export */   "RW": function() { return /* binding */ applyOverrides; },
/* harmony export */   "X2": function() { return /* binding */ runForEachTier; }
/* harmony export */ });
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47037);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55674);
/* harmony import */ var services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55551);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var isObject = function(value) {
    return typeof value === "object" && value !== null;
};
var runForEachTier = function(callback) {
    Object.keys(constants_pricing__WEBPACK_IMPORTED_MODULE_1__/* .TIERS */ .Iy).forEach(function(tierKey) {
        return callback(constants_pricing__WEBPACK_IMPORTED_MODULE_1__/* .TIERS */ .Iy[tierKey]);
    });
};
var EMPTY_ARRAY = []; // used in multiple places.
var getFirstTranslatedString = function(stringsArray) {
    if (!stringsArray || stringsArray.length === 0) return "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = stringsArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_2__[key]) {
                return key; // will be translated by the component.
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // couldn't find a translation for this value - treating it as a regular string, possibly enclosed in an array.
    if (Array.isArray(stringsArray)) {
        return "".concat(stringsArray[0]);
    }
    return "".concat(stringsArray);
};
var applyOverrides = function(originalObject, overridesObject, keys) {
    var returnedObject = _object_spread({}, originalObject);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var overrideValue = overridesObject === null || overridesObject === void 0 ? void 0 : overridesObject[key];
            if (lodash_isString__WEBPACK_IMPORTED_MODULE_0___default()(overrideValue) || Array.isArray(overrideValue)) {
                returnedObject[key] = getFirstTranslatedString(overridesObject[key]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return returnedObject;
};


/***/ }),

/***/ 69017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LF": function() { return /* binding */ getPricingPageSectionsFromClusterConfig; },
  "vT": function() { return /* binding */ getTierDescriptionsFromClusterConfig; },
  "A2": function() { return /* binding */ getValueFeaturesFromClusterConfig; },
  "dn": function() { return /* binding */ isInClusterTest; }
});

// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(39693);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/tier-descriptions/index.js
var pricing_page_tier_descriptions = __webpack_require__(87529);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/default_sections.js
var default_sections = __webpack_require__(16168);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/features.js + 3 modules
var features = __webpack_require__(61980);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/clusters/marketing.js


var COMMUNICATION_ESSENTIALS = function(param) {
    var cookies = param.cookies, abTests = param.abTests;
    return {
        sectionName: "pricingPage.features.sections.communication_essentials",
        features: [
            features.COMMUNICATION_WITH_CONTEXT,
            features.COLLABORATIVE_WHITEBOARD,
            features.INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK,
            features.STORAGE({
                cookies: cookies,
                abTests: abTests
            })
        ]
    };
};
var COLLABORATION_AND_SHARING_ESSENTIALS = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.collaboration_and_sharing_essentials",
        features: [
            features.EMBED_DOCUMENTS_AND_BRIEFS,
            features.MARKETING_REQUESTS_WITH_FORMS,
            features.READY_MADE_MARKETING_TEMPLATES,
            features.DEADLINE_MANAGEMENT,
            features.SHARE_BOARD_WITH_EXTERNAL_GUESTS,
            features.UNLIMITED_VIEWERS,
            features.AUTOMATIONS,
            features.MARKETING_INTEGRATIONS,
            features.TIMELINE({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
var INSIGHTS_ESSENTIALS = {
    sectionName: "pricingPage.features.sections.insights_essentials",
    features: [
        features.MARKETING_DASHBOARDS,
        features.MARKETING_CALENDAR,
        features.DAILY_REPORTS
    ]
};
var MARKETING_OTHER_ESSENTIALS = {
    sectionName: "pricingPage.features.sections.other_essentials",
    features: [
        features.IMPORT_EXPORT_EXCEL,
        features.UNLIMITED_BOARDS,
        features.ADVANCED_COLUMN_TYPES,
        features.MOBILE,
        features.ACTIVITY_LOG,
        features.ZOOM_INTEGRATION
    ]
};
var MARKETING_ADVANCED_SECTION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.advanced",
        features: [
            features.KANBAN_VIEW,
            features.MAP,
            features.SEARCH,
            features.FORMS_CUSTOMIZATION({
                hasStudentPlan: hasStudentPlan
            }),
            features.TIME_TRACKING,
            features.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            features.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            features.TAGS,
            features.PRIVATE_BOARDS
        ]
    };
};

// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/free_tier_essentials.js
var free_tier_essentials = __webpack_require__(8876);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/default_essentials.js

var DEFAULT_ESSENTIALS = function(cookies, abTests) {
    return {
        sectionName: "pricingPage.features.sections.essentials",
        features: [
            features.UNLIMITED_VIEWERS,
            features.UNLIMITED_BOARDS,
            features.UNLIMITED_DOCS,
            features.COLUMN_TYPES({
                cookies: cookies
            }),
            features.MOBILE,
            features.STORAGE({
                cookies: cookies,
                abTests: abTests
            }),
            features.ACTIVITY_LOG
        ]
    };
};

;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/all_sections.js




var ESSENTIALS = function(param) {
    var abTests = param.abTests, cookies = param.cookies, hasFreeTier = param.hasFreeTier;
    if (hasFreeTier) {
        return (0,free_tier_essentials/* getFreeTierEssentials */.b)(abTests, cookies);
    }
    return DEFAULT_ESSENTIALS(cookies, abTests);
};
var ALL_SECTIONS = {
    ESSENTIALS: ESSENTIALS,
    REMOTE_WORK_FEATURES_SECTION: default_sections/* REMOTE_WORK_FEATURES_SECTION */.RV,
    ADVANCED: default_sections/* ADVANCED */.UO,
    SECURITY: default_sections/* SECURITY */.lG,
    ADVANCED_REPORTING: default_sections/* ADVANCED_REPORTING */.k3,
    SUPPORT: default_sections/* SUPPORT */.wL,
    COMMUNICATION_ESSENTIALS: COMMUNICATION_ESSENTIALS,
    ADMINISTRATION_AND_CONTROL: default_sections/* ADMINISTRATION_AND_CONTROL */.Xn,
    SECURITY_NEW: default_sections/* SECURITY_NEW */._h,
    SUPPORT_NEW: default_sections/* SUPPORT_NEW */.QA,
    COLLABORATION_AND_SHARING_ESSENTIALS: COLLABORATION_AND_SHARING_ESSENTIALS,
    INSIGHTS_ESSENTIALS: INSIGHTS_ESSENTIALS,
    MARKETING_OTHER_ESSENTIALS: MARKETING_OTHER_ESSENTIALS,
    MARKETING_ADVANCED_SECTION: MARKETING_ADVANCED_SECTION,
    CUSTOMER_FAVORITES: default_sections/* CUSTOMER_FAVORITES */.Kk,
    COLLABORATION: default_sections/* COLLABORATION */.iz,
    PRODUCTIVITY: default_sections/* PRODUCTIVITY */.nD,
    VIEWS_AND_REPORTING: default_sections/* VIEWS_AND_REPORTING */.uK,
    SECURITY_AND_PRIVACY: default_sections/* SECURITY_AND_PRIVACY */.K8,
    ENTERPRISE_REPORTING_AND_ANALYTICS: default_sections/* ENTERPRISE_REPORTING_AND_ANALYTICS */.zw
};
/* harmony default export */ var all_sections = (ALL_SECTIONS);

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-helper-service.js
var clusterized_pricing_page_helper_service = __webpack_require__(85920);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-features-service.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








var DEFAULT_FEATURE_KEYS = [
    "name",
    "description"
];
var DEFAULT_SECTION_KEYS = [
    "sectionName"
];
var isFeatureValid = function(feature) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = DEFAULT_FEATURE_KEYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!isString_default()(feature[key]) || feature[key].length === 0) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!feature.tiers || Object.keys(feature.tiers).length === 0) return false;
    return true;
};
var isSectionValid = function(section) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = DEFAULT_SECTION_KEYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!isString_default()(section[key]) || section[key].length === 0) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!section.features || section.features.length === 0) return false;
    return true;
};
var convertStringToFeatureTierValue = function(stringValue) {
    if (!stringValue) return false;
    if (stringValue == "true") return true;
    return (0,clusterized_pricing_page_helper_service/* getFirstTranslatedString */.Am)(clusterized_pricing_page_helper_service/* EMPTY_ARRAY.concat */.LZ.concat(stringValue));
};
var getFeatureTierValue = function(tier, tiersObject, feature) {
    if (tiersObject && tiersObject[tier]) {
        return {
            value: convertStringToFeatureTierValue(tiersObject[tier])
        };
    } else if (tier === pricing/* TIERS.FREE */.Iy.FREE) {
        // free tier gets, by default, the value of the basic tier, unless defined otherwise.
        return getFeatureTierValue(pricing/* TIERS.BASIC */.Iy.BASIC, tiersObject, feature);
    } else if (!(feature === null || feature === void 0 ? void 0 : feature.tiers[tier])) {
        // no value defined for this tier, and it's a new feature
        return {
            value: false
        };
    }
    return feature.tiers[tier];
};
var generateDefaultTiersObject = function() {
    var tiersObject = {};
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        tiersObject[tier] = {
            value: false
        };
    });
    return tiersObject;
};
/**
 * Retrieves a feature's default values by that feature's name, and returns those values as a feature object.
 * @param {*} featureName - assumed to be uppercased, to match the constant.
 * @param {*} abTests - for features whose default value depends on A/B test variants.
 * @param {*} cookies - for features whose default value depends on cookies.
 */ var getExistingFeature = function(featureName, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (typeof features[featureName] === "function") {
        return features[featureName]({
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    }
    var feature = features[featureName];
    return feature ? _object_spread({}, feature) : null;
};
var convertFeature = function(featureNameOrObject, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (isString_default()(featureNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code feature, it will be used.
        var feature = getExistingFeature(featureNameOrObject, {
            abTests: abTests,
            cookies: cookies,
            hasFreeTier: hasFreeTier,
            hasStudentPlan: hasStudentPlan
        });
        if (!feature) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                kind: "name",
                placement: "features",
                data: featureNameOrObject
            });
            return null;
        }
        return feature;
    }
    // got an object - verifying that it has a name (either an existing feature's or an override)
    var feature1 = featureNameOrObject.feature, featureName = featureNameOrObject.featureName, overrides = featureNameOrObject.overrides; // 'featureName' for backwards compatibility - TODO remove after fixing existing configs.
    if (!feature1 && !featureName && !(overrides === null || overrides === void 0 ? void 0 : overrides.name)) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
            kind: "object",
            placement: "features",
            data: featureNameOrObject
        });
        return null; // must have either an existing feature's name, or a new one.
    }
    // overriding name and description:
    var existingFeature = getExistingFeature(feature1, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || getExistingFeature(featureName, {
        abTests: abTests,
        cookies: cookies,
        hasFreeTier: hasFreeTier,
        hasStudentPlan: hasStudentPlan
    }) || {}; // using an existing feature if one matches the name. Features can be identified either by 'feature' or 'featureName'.
    var featureWithOverrides = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingFeature, featureNameOrObject === null || featureNameOrObject === void 0 ? void 0 : featureNameOrObject.overrides, DEFAULT_FEATURE_KEYS);
    // overriding tiers:
    var tiers = (overrides || {}).tiers;
    if (!featureWithOverrides.tiers) {
        // new feature - no tiers defined
        featureWithOverrides.tiers = generateDefaultTiersObject();
    }
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        featureWithOverrides.tiers[tier] = getFeatureTierValue(tier, tiers, featureWithOverrides);
    });
    if (!isFeatureValid(featureWithOverrides)) return null;
    return featureWithOverrides;
};
/**
 * Retrieves a section's default values (name and features list) by that section's name, and returns those as a
 * section object.
 * @param {*} sectionName
 * @param {*} abTests - in case the section data depends on AB tests.
 * @param {*} cookies - in case the section data depends on cookies.
 */ var getExistingSection = function(sectionName, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    var originalSection;
    if (typeof all_sections[sectionName] === "function") {
        originalSection = all_sections[sectionName]({
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    } else {
        originalSection = all_sections[sectionName];
    }
    return originalSection ? _object_spread({}, originalSection) : null;
};
var convertSection = function(sectionNameOrObject, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (isString_default()(sectionNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code section, that section will be used.
        var section = getExistingSection(sectionNameOrObject, {
            abTests: abTests,
            cookies: cookies,
            hasFreeTier: hasFreeTier,
            hasStudentPlan: hasStudentPlan
        });
        if (!section) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                kind: "name",
                placement: "sections",
                data: sectionNameOrObject
            });
            return null;
        }
        return section;
    }
    // creating a section object using the given input
    var section1 = sectionNameOrObject.section, sectionName = sectionNameOrObject.sectionName, overrides = sectionNameOrObject.overrides; // 'sectionName' for backwards compatibility - TODO remove after fixing existing configs
    if (!section1 && !sectionName && !(overrides === null || overrides === void 0 ? void 0 : overrides.sectionName)) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
            placement: "sections",
            kind: "object",
            data: sectionNameOrObject
        });
        return null; // must have an existing section's name, or a new one.
    }
    var existingSection = getExistingSection(section1, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || getExistingSection(sectionName, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || {}; // using an existing section if one matches the name.
    var sectionWithOverrides = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingSection, overrides, DEFAULT_SECTION_KEYS);
    if (!sectionWithOverrides.features) {
        sectionWithOverrides.features = [];
    }
    if (overrides === null || overrides === void 0 ? void 0 : overrides.features) {
        sectionWithOverrides.features = compact_default()(overrides.features.map(function(feature) {
            return convertFeature(feature, {
                abTests: abTests,
                cookies: cookies,
                hasStudentPlan: hasStudentPlan,
                hasFreeTier: hasFreeTier
            });
        }));
    }
    if (!isSectionValid(sectionWithOverrides)) return null;
    return sectionWithOverrides;
};
var convertSectionToPricingPageSection = function(value, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return convertSection(value, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
};

// EXTERNAL MODULE: ./constants/pricing/pricing-page/value-features/index.js
var value_features = __webpack_require__(69078);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_features.js
var features_value_features = __webpack_require__(49127);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-value-features-service.js
function clusterized_pricing_page_value_features_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clusterized_pricing_page_value_features_service_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clusterized_pricing_page_value_features_service_define_property(target, key, source[key]);
        });
    }
    return target;
}








var isValueFeatureValid = function(valueFeature) {
    return isString_default()(valueFeature === null || valueFeature === void 0 ? void 0 : valueFeature.name) && isString_default()(valueFeature === null || valueFeature === void 0 ? void 0 : valueFeature.text) && valueFeature.name.length > 0 && valueFeature.text.length > 0;
};
var getExistingValueFeature = function(valueFeatureName) {
    if (isValueFeatureValid(features_value_features[valueFeatureName])) {
        return clusterized_pricing_page_value_features_service_object_spread({}, features_value_features[valueFeatureName]);
    }
    return null;
};
var getValueFeatureOrNull = function(valueFeatureNameOrObject) {
    if (isString_default()(valueFeatureNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code value feature, it will be used.
        var valueFeature = getExistingValueFeature(valueFeatureNameOrObject);
        if (!valueFeature) {
            // missing value feature - emitting event
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                placement: "value_features",
                kind: "name",
                data: valueFeatureNameOrObject
            });
        }
        return valueFeature; // will be null if no such value feature exists.
    } else if ((0,clusterized_pricing_page_helper_service/* isObject */.Kn)(valueFeatureNameOrObject)) {
        var feature = valueFeatureNameOrObject.feature, name = valueFeatureNameOrObject.name, overrides = valueFeatureNameOrObject.overrides; // 'name' is there for backwards compatibility - TODO remove
        var existingFeature = getExistingValueFeature(feature) || getExistingValueFeature(name) || {};
        var overrideKeys = [
            "name",
            "text",
            "link"
        ];
        var resultingFeature = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingFeature, overrides, overrideKeys);
        if (!isValueFeatureValid(resultingFeature)) {
            // no source for the value feature's name and text (either a code-based existing feature or config-delivered) -
            // returning null.
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                placement: "value_features",
                kind: "object",
                data: valueFeatureNameOrObject
            });
            return null;
        }
        return resultingFeature;
    }
    // value must be a string or an object.
    (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
        placement: "value_features",
        kind: "invalid_type",
        data: valueFeatureNameOrObject
    });
    return null;
};
var getClusterizedValueFeatures = function(clusterValueFeatures, param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var valueFeaturesObject = clusterized_pricing_page_value_features_service_object_spread({}, (0,value_features/* DEFAULT_VALUE_FEATURES_PER_TIER */.S)({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    }));
    // overriding default values (using existing value features) on a per-tier basis
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        if (tier === pricing/* TIERS.FREE */.Iy.FREE) return;
        // the Individual plan top features aren't shown at the moment, since it's a reduced, controlled plan.
        var tierClusterFeatures = clusterValueFeatures[tier];
        if (Array.isArray(tierClusterFeatures) && tierClusterFeatures.length > 0) {
            valueFeaturesObject[tier] = compact_default()(tierClusterFeatures.map(getValueFeatureOrNull));
        }
    });
    return valueFeaturesObject;
};

;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js
function clusterized_pricing_page_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clusterized_pricing_page_service_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clusterized_pricing_page_service_define_property(target, key, source[key]);
        });
    }
    return target;
}









var isInClusterTest = function(clusterConfig, param) {
    var abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    return true;
    return false;
    if (!(clusterConfig === null || clusterConfig === void 0 ? void 0 : clusterConfig.payments_view)) return false; // no payments config -> no AB test
    var abTestConfig = (clusterConfig === null || clusterConfig === void 0 ? void 0 : clusterConfig.payments_view).abTestConfig;
    if (!(abTestConfig === null || abTestConfig === void 0 ? void 0 : abTestConfig.homepage)) return true; // cluster pricing config is active by default if there isn't a homepage test
    var _homepage = abTestConfig.homepage, disableTest = _homepage.disableTest, testName = _homepage.testName, newVariationName = _homepage.newVariationName, sendBigBrainEvent = _homepage.sendBigBrainEvent, syncCookieName = _homepage.syncCookieName, syncCookieValue = _homepage.syncCookieValue, homepageSyncCookieName = _homepage.homepageSyncCookieName, configForcePricing = _homepage.forcePricing;
    // checking: the test was manually disabled for now
    if (disableTest === "true" || disableTest === true) {
        return true;
    }
    // checking: 'forcePricing' value was passed
    if (configForcePricing && configForcePricing === forcePricing) {
        return true;
    }
    // checking: the user already received a platform variant
    // TODO return after caching issues have been fully cleared
    if (cookies) {
        var matchingPlatformCookie = cookies[syncCookieName];
        if (matchingPlatformCookie && syncCookieValue && matchingPlatformCookie === syncCookieValue) {
            // otherwise, undefined === undefined.
            return true; // achieved via platform <--> homepage test synchronization.
        }
    }
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, testName, sendBigBrainEvent);
    // if we want to synchronize the homepage's AB test result to the platform:
    // TODO return after caching issues have been fully cleared
    if (isString_default()(homepageSyncCookieName) && isString_default()(abTestVariant)) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(homepageSyncCookieName, abTestVariant);
    }
    return abTestVariant === newVariationName;
};
// Expected input:
// { sections:
//  ([ESSENTIALS, ...] or [{sectionName: 'ESSENTIALS', overrides: ...}])
// }
var getPricingPageSectionsFromClusterConfig = function(pricingConfig, param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? {} : _abTests, _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _hasStudentPlan = param.hasStudentPlan, hasStudentPlan = _hasStudentPlan === void 0 ? false : _hasStudentPlan, _hasFreeTier = param.hasFreeTier, hasFreeTier = _hasFreeTier === void 0 ? false : _hasFreeTier;
    if (!(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig) || !Array.isArray(pricingConfig.sections)) return;
    var sections = pricingConfig.sections;
    return compact_default()(sections.map(function(section) {
        return convertSectionToPricingPageSection(section, {
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    }));
};
var getTierDescriptionsFromClusterConfig = function(pricingConfig, clusterId, param) {
    var hasStudentPlan = param.hasStudentPlan, cookies = param.cookies, abTests = param.abTests, forcePricing = param.forcePricing;
    if (!(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig) || !(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig.tier_descriptions)) return;
    // getting default tier descriptions
    var tier_descriptions = pricingConfig.tier_descriptions;
    var returnedDescriptions = clusterized_pricing_page_service_object_spread({}, (0,pricing_page_tier_descriptions/* getDefaultTierDescriptions */.O)({
        hasStudentPlan: hasStudentPlan
    }));
    // overriding them if any exist
    if ((0,clusterized_pricing_page_helper_service/* isObject */.Kn)(tier_descriptions)) {
        (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
            if (tier === pricing/* TIERS.FREE */.Iy.FREE) return; // Individual plan sees the same descriptions regardless of cluster.
            if (isString_default()(tier_descriptions[tier])) {
                returnedDescriptions[tier] = tier_descriptions[tier];
            }
        });
    }
    return returnedDescriptions;
};
var getValueFeaturesFromClusterConfig = function(clusterValueFeatures, param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies;
    if (!clusterValueFeatures || !(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(clusterValueFeatures)) return;
    return getClusterizedValueFeatures(clusterValueFeatures, {
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies
    });
};


/***/ }),

/***/ 43331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ productPrices; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78803);
/* harmony import */ var constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__);


var free = {
    usd: 0,
    euro: 0,
    gbp: 0,
    cad: 0,
    aud: 0,
    brl: 0,
    mxn: 0,
    inr: 0,
    jpy: 0
};
var _obj, _obj1, _obj2, _obj3, _obj4;
var productPrices = {
    core: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1400
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 18,
                cad: 27,
                aud: 27,
                brl: 91,
                mxn: 400,
                inr: 1500,
                jpy: 2200
            },
            enterprise: {
                usd: 46,
                euro: 46,
                gbp: 40,
                cad: 62,
                aud: 62,
                brl: 217,
                mxn: 920,
                inr: 3450,
                jpy: 4700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            pro: {
                usd: 16,
                euro: 16,
                gbp: 14,
                cad: 22,
                aud: 22,
                brl: 75,
                mxn: 320,
                inr: 1200,
                jpy: 1800
            },
            enterprise: {
                usd: 38,
                euro: 38,
                gbp: 33,
                cad: 51,
                aud: 51,
                brl: 178,
                mxn: 760,
                inr: 2850,
                jpy: 4200
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 37,
                mxn: 150,
                inr: 550,
                jpy: 850
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 60,
                mxn: 240,
                inr: 900,
                jpy: 1400
            },
            pro: {
                usd: 27,
                euro: 27,
                gbp: 23,
                cad: 37,
                aud: 37,
                brl: 135,
                mxn: 540,
                inr: 2000,
                jpy: 3000
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 46,
                cad: 74,
                aud: 74,
                brl: 270,
                mxn: 1100,
                inr: 4025,
                jpy: 6100
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 6,
                euro: 6,
                gbp: 5,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 700
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 50,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            pro: {
                usd: 22,
                euro: 22,
                gbp: 19,
                cad: 30,
                aud: 30,
                brl: 110,
                mxn: 440,
                inr: 1650,
                jpy: 2500
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 38,
                cad: 60,
                aud: 60,
                brl: 220,
                mxn: 900,
                inr: 3300,
                jpy: 5000
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1700
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 18,
                cad: 27,
                aud: 27,
                brl: 91,
                mxn: 400,
                inr: 1500,
                jpy: 3300
            },
            enterprise: {
                usd: 46,
                euro: 46,
                gbp: 40,
                cad: 62,
                aud: 62,
                brl: 217,
                mxn: 920,
                inr: 3450,
                jpy: 4700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 1100
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1400
            },
            pro: {
                usd: 16,
                euro: 16,
                gbp: 14,
                cad: 22,
                aud: 22,
                brl: 75,
                mxn: 320,
                inr: 1200,
                jpy: 2700
            },
            enterprise: {
                usd: 38,
                euro: 38,
                gbp: 33,
                cad: 51,
                aud: 51,
                brl: 178,
                mxn: 760,
                inr: 2850,
                jpy: 4200
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1700
            },
            pro: {
                usd: 24,
                euro: 24,
                gbp: 21,
                cad: 32,
                aud: 32,
                brl: 108,
                mxn: 475,
                inr: 1780,
                jpy: 3300
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 46,
                cad: 74,
                aud: 74,
                brl: 270,
                mxn: 1100,
                inr: 4025,
                jpy: 6100
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 1100
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1400
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 17,
                cad: 26,
                aud: 26,
                brl: 89,
                mxn: 380,
                inr: 1425,
                jpy: 2700
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 38,
                cad: 60,
                aud: 60,
                brl: 220,
                mxn: 900,
                inr: 3300,
                jpy: 5000
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 49,
                mxn: 240,
                inr: 890,
                jpy: 1530
            },
            standard: {
                usd: 14,
                euro: 14,
                gbp: 13,
                cad: 20,
                aud: 20,
                brl: 65,
                mxn: 280,
                inr: 1060,
                jpy: 1990
            },
            pro: {
                usd: 24,
                euro: 24,
                gbp: 21,
                cad: 32,
                aud: 32,
                brl: 105,
                mxn: 480,
                inr: 1770,
                jpy: 3890
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 47,
                cad: 73,
                aud: 73,
                brl: 255,
                mxn: 1080,
                inr: 4070,
                jpy: 8700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 9,
                euro: 9,
                gbp: 8,
                cad: 13,
                aud: 13,
                brl: 41,
                mxn: 190,
                inr: 710,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 53,
                mxn: 240,
                inr: 890,
                jpy: 1650
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 17,
                cad: 26,
                aud: 26,
                brl: 89,
                mxn: 380,
                inr: 1400,
                jpy: 3200
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 39,
                cad: 60,
                aud: 60,
                brl: 210,
                mxn: 900,
                inr: 3360,
                jpy: 7200
            }
        }
    }), _obj),
    marketing: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), _obj1),
    crm: (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 3,
                euro: 3,
                gbp: 2,
                cad: 4,
                aud: 4,
                brl: 16,
                mxn: 60,
                inr: 210,
                jpy: 330
            },
            standard: {
                usd: 6,
                euro: 6,
                gbp: 5,
                cad: 8,
                aud: 8,
                brl: 29,
                mxn: 120,
                inr: 440,
                jpy: 680
            },
            pro: {
                usd: 9,
                euro: 9,
                gbp: 10,
                cad: 16,
                aud: 16,
                brl: 59,
                mxn: 220,
                inr: 880,
                jpy: 1330
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 3,
                euro: 3,
                gbp: 2,
                cad: 5,
                aud: 3,
                brl: 12,
                mxn: 40,
                inr: 170,
                jpy: 260
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 3,
                cad: 6,
                aud: 6,
                brl: 24,
                mxn: 90,
                inr: 350,
                jpy: 530
            },
            pro: {
                usd: 9,
                euro: 9,
                gbp: 7,
                cad: 13,
                aud: 13,
                brl: 46,
                mxn: 180,
                inr: 720,
                jpy: 1050
            },
            enterprise: free
        }
    }), _obj2),
    projectManagement: (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), _obj3),
    software: (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 0,
                euro: 0,
                gbp: -0.5,
                cad: -0.3,
                aud: -0.3,
                brl: 4,
                mxn: 0,
                inr: 10,
                jpy: -5
            },
            standard: {
                usd: 0.5,
                euro: 0.5,
                gbp: 0,
                cad: 0.3,
                aud: 0.3,
                brl: 2,
                mxn: 10,
                inr: 27.5,
                jpy: -10
            },
            pro: {
                usd: 1,
                euro: 1,
                gbp: 1,
                cad: 1.6,
                aud: 1.6,
                brl: 10,
                mxn: 20,
                inr: 105,
                jpy: -30
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 0,
                euro: 0,
                gbp: -0.2,
                cad: -0.7,
                aud: -0.7,
                brl: -1,
                mxn: -10,
                inr: -35,
                jpy: -85
            },
            standard: {
                usd: 0,
                euro: 0,
                gbp: -0.5,
                cad: -0.3,
                aud: -0.3,
                brl: 2,
                mxn: 0,
                inr: 10,
                jpy: -25
            },
            pro: {
                usd: 1,
                euro: 1,
                gbp: 0,
                cad: 1.3,
                aud: 1.3,
                brl: 6,
                mxn: 20,
                inr: 100,
                jpy: -50
            },
            enterprise: free
        }
    }), _obj4)
};


/***/ })

}]);